/**
 * @file 简体中文话术
 * @author zhujialu
 */
define(function (require, exports) {
    'use strict'

    /**
     * =================================================
     * 用户角色
     * =================================================
     */

    exports.USER_ROLE_TEACHER = '先生'

    exports.USER_ROLE_STUDENT = '学生'

    exports.USER_ROLE_GUEST = '観光客'

    exports.USER_ROLE_ASSISTANT = '教えを助ける'

    exports.USER_ROLE_SPECIAL_GUEST = 'ゲスト人'

    exports.USER_ASSISTANT_NUMBER = '助教${number}'

    /**
     * =================================================
     * 老师状态
     * =================================================
     */

    exports.TEACHER_UNKNOW = '先生は教室に入っていません。'

    exports.TEACHER_IN = '先生は教室に入りました。'

    exports.TEACHER_OUT = '先生は教室を離れました。'

    exports.TEACHER_AUDIO_ON = '先生はマイクをつけました。'

    exports.TEACHER_AUDIO_OFF = '先生はマイクを切っています。'

    exports.TEACHER_VIDEO_ON = '先生はカメラをつけました。'

    exports.TEACHER_VIDEO_OFF = '老师已关摄像头'

    /**
     * =================================================
     * 用户状态
     * =================================================
     */

    exports.USER_OUT = '教室を離れました'

    exports.USER_AUDIO_ON = 'マイクを開けました'

    exports.USER_AUDIO_OFF = 'オフマイク'

    exports.USER_VIDEO_ON = 'カメラを開けました'

    exports.USER_VIDEO_OFF = 'カメラを停止しました'

    /**
     * =================================================
     * 自己状态
     * =================================================
     */

    exports.SELF_AUDIO_ON = 'マイクを開けました'

    exports.SELF_AUDIO_OFF = 'オフマイク'

    exports.SELF_VIDEO_ON = 'カメラを開けました'

    exports.SELF_VIDEO_OFF = 'カメラを停止しました'

    /**
     * =================================================
     * 画质
     * =================================================
     */

    exports.VIDEO_QUALITY_LOW = '滑らかである'

    exports.VIDEO_QUALITY_MEDIUM = '鮮明である'

    exports.VIDEO_QUALITY_HIGH = 'ハイビジョン'

    exports.VIDEO_QUALITY_SUPER = '超清'

    exports.VIDEO_QUALITY_720P = '720 p'

    exports.VIDEO_QUALITY_1080P = '1080 p'

    /**
     * =================================================
     * 百家云终端类型
     * =================================================
     */

    exports.END_TYPE_PC_BROWSER_BJY = 'コンピュータのホームページ'

    exports.END_TYPE_PC_CLIENT_BJY = 'pcクライアント'

    exports.END_TYPE_MAC_CLIENT_BJY = 'macクライアント'

    exports.END_TYPE_MOBILE_BROWSER_BJY = '携帯のホームページ'

    exports.END_TYPE_MOBILE_XIAOCHENGXU = 'wechatアプレット'

    exports.END_TYPE_MOBILE_APPLE_BJY = 'アップル'

    exports.END_TYPE_MOBILE_ANDROID_BJY = 'アンドロイドアプリ'

    exports.END_TYPE_MINI_PROGRAM_BJY = 'アプレット'

    exports.END_TYPE_WEBRTC_BJY = '麦をのせる'

    exports.END_TYPE_UNKNOWN_BJY = '未知'

    /**
     * =================================================
     * 音视频链路状态
     * =================================================
     */

    exports.AV_PLAY_STATUS_CONNECTING = '相手と接続中…'

    exports.AV_PLAY_STATUS_FAIL = '接続の確立に失敗しました'

    exports.AV_PLAY_STATUS_BUFFERING = 'データをバッファしています。'

    /**
     * =================================================
     * 快捷键
     * =================================================
     */

    exports.SHORTCUT_EXIT_FULLSCREEN = '退出全屏可按 Esc 键'

    /**
     * =================================================
     * 按钮
     * =================================================
     */

    exports.BUTTON_SUBMIT = 'を選択します'

    exports.BUTTON_CLOSE = '閉じる'

    exports.BUTTON_CANCEL = 'キャンセル'

    exports.BUTTON_ACCEPT = '首を縦に振る'

    exports.BUTTON_REJECT = '拒否'

    exports.BUTTON_REFRESH = '更新'

    exports.BUTTON_TRY_REFRESH = '再試行を更新'

    exports.BUTTON_CLOSE_ROOM = '放送を停止する'

    exports.BUTTON_REENTER = '重新进入教室'

    exports.BUTTON_LEAVE = '教室を出る'

    exports.BUTTON_START_CLASS = '授業を受ける'

    exports.BUTTON_START_CLASS_FOR_SELL = '开播'

    exports.BUTTON_END_CLASS = '授業が終わる'

    exports.BUTTON_END_CLASS_FOR_SELL = '蒔き付けをする'

    exports.BUTTON_LEAVE_CLASS_AND_REMOVE_ALL = '学生から離れて移動する。'

    exports.BUTTON_END_CLASS_AND_REMOVE_ALL = '授業を終えて学生を移す'

    exports.BUTTON_STOP_RTMP_PUSH = '放送禁止'

    exports.BUTTON_PLAY_MEDIA = '再生'

    exports.BUTTON_RECORD_CLASS = '授業をとる'

    exports.BUTTON_START_RECORD_CLASS = '開始'

    exports.BUTTON_STOP_RECORD_CLASS = '停录'

    exports.BUTTON_RESTART_RECORD_CLASS = '続録'

    exports.BUTTON_RECORD_FULLSCREEN = 'フルスクリーンで授業をとる'

    exports.BUTTON_RECORD_AREA = '区域录课'

    exports.BUTTON_START_SCREEN_SHARE = 'スクリーン共有'

    exports.BUTTON_QUESTION_ANSWER = '問答'

    exports.BUTTON_EXAM = '法廷に従って試験する'
    exports.BUTTON_END_EXAM = '结束随堂考'

    exports.BUTTON_STOP_SCREEN_SHARE = '終了'

    exports.BUTTON_RECORD_SETTINGS = '授業の設定を記録します'

    exports.BUTTON_THIRD_PUSH = 'プッシュフローサービス'

    exports.BUTTON_FORBID_MIC = '禁音'

    exports.BUTTON_CANCEL_FORBID_MIC = '禁音を消す'

    exports.BUTTON_SURVEY = 'テスト'

    exports.BUTTON_LOTTERY = 'くじを引く'

    exports.BUTTON_ANSWER = '解答器'

    exports.BUTTON_DEBUG = '调试'

    exports.BUTTON_TIMER = 'タイマー'

    exports.BUTTON_RED_PACKET = '紅包雨'

    exports.BUTTON_ENTER_FULLSCREEN = 'フルスクリーン'

    exports.BUTTON_EXIT_FULLSCREEN = 'フルスクリーンを終了'

    exports.BUTTON_OPEN_CAMERA = '開いていません'

    exports.BUTTON_CLOSE_CAMERA = 'オープンしました'

    exports.BUTTON_OPEN_MIC = '開いていません'

    exports.BUTTON_CLOSE_MIC = 'オープンしました'

    exports.BUTTON_SPEAK_APPLY = '手を挙げる'

    exports.BUTTON_SPEAK_APPLY_CANCEL = 'キャンセル'

    exports.BUTTON_END_SPEAK = '終了'

    exports.BUTTON_MANAGE_DOCUMENT = '私の授業'

    exports.BUTTON_ADD_DOCUMENT = '追加'

    exports.BUTTON_REMOVE_DOCUMENT = '削除'

    exports.BUTTON_DELETE_DOCUMENT = '削除'

    exports.BUTTON_SUBMIT_DOCUMENT = '選択を確認する'

    exports.BUTTON_ADD_DOCUMENT_FORM_NETDESK = 'データベースの選択'

    exports.BUTTON_UPLOAD_DOCUMENT = '一般レッスン'

    exports.BUTTON_SEND_MESSAGE = '送信'

    exports.BUTTON_GIFT = '飲み物をサービスします'

    exports.BUTTON_EDIT_NOTICE = '公告を編集する'

    exports.BUTTON_SAVE_NOTICE = '保存公告'

    exports.BUTTON_SWITCH_GIFT = '换一杯'

    exports.BUTTON_SEND_GIFT_TO_TEACHER = '先生にプレゼントします'

    exports.BUTTON_FORBID_USER_SEND_MESSAGE = 'チャット禁止'

    exports.BUTTON_UNFORBID_USER_SEND_MESSAGE = 'taに対する禁止を取り消す。'

    exports.BUTTON_SURVEY_ADD_OPTION = 'オプションを追加'

    exports.BUTTON_NEED = '必要'

    exports.BUTTON_NO_NEED = 'いらないです'

    exports.BUTTON_REPLY_SUBMIT = '答えを確認する'

    exports.BUTTON_MINIMIZE = '最小化'

    exports.BUTTON_HELP = '助けを求める'

    exports.BUTTON_ASSISTANT_LINK = '助教リンク'

    exports.BUTTON_JOIN_USERLIST = '出席リスト'

    exports.BUTTON_ATTENTION_DETECTION = '集中度検出'

    exports.BUTTON_GEN_LINK = 'リンクを生成'

    exports.BUTTON_COPY_LINK = 'コピー'

    exports.BUTTON_COPY_LINK_SUCC = '成功'

    exports.BUTTON_COMMENT = '評価'

    exports.BUTTON_DETECT = '检测'

    exports.BUTTON_MORE = '詳細'

    exports.BUTTON_NEXT_STEP = '次のステップ'

    exports.BUTTON_COMPLETE = '完了'

    exports.BUTTON_COMMENT_SUBMIT = 'コメントを送信'

    exports.BUTTOM_COMMENT_SEND = '先生を評価する'

    exports.BUTTON_COMMENT_CANCEL = '私は評価しません'

    exports.BUTTON_SHOW_LOGS = 'ログを展開'

    exports.BUTTON_HIDE_LOGS = '日誌をたたむ'

    exports.BUTTON_RETURN = '戻る'

    exports.BUTTON_SERVER_ROUTE = '線路'

    exports.BUTTON_SERVER_SUGGEST = '首选线路'

    exports.BUTTON_SERVER_BACKUP = '备选线路'

    exports.BUTTON_SWITCH_TO_ONLINE = '身を見せる'

    exports.BUTTON_SWITCH_TO_OFFLINE = '身を忍ぶ'

    exports.BUTTON_MODIFY = '変更'

    exports.BUTTON_UNFORBID_ALL = '禁言を取り消す'

    exports.BUTTON_COMMENT_REQ_MORE = 'もっと見る'

    exports.BUTTON_COMMENT_NO_MORE = '到底啦'

    exports.BUTTON_UPGRADE_CLIENT = '升级新版'

    exports.BUTTON_USE_GUIDE = '客户端使用教程'

    exports.BUTTON_SWITCH_OPEN = '開く'

    exports.BUTTON_SWITCH_CLOSE = 'オフ'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ME = '私だけを見て'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_TEACHER = '先生だけを見ます'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ALL = '全部'

    exports.BUTTON_SETTING_MORE_DETAIL = '詳細設定'

    exports.BUTTON_BARRAGE_ON = '弾幕が開く'

    exports.BUTTON_BARRAGE_OFF = '弾幕関'

    exports.BUTTON_SYSTEM_SOUND = 'システム音'

    exports.BUTTON_SWITCH_LAYOUT = 'レイアウトを切り替え'

    exports.BUTTON_FORBID_RAISE_HAND_OFF = '挙手を許す'

    exports.BUTTON_FORBID_RAISE_HAND_ON = '挙手禁止'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_OFF = '学生の手を上げることを許可します'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_ON = '学生の手を挙げてはいけません'

    exports.BUTTON_SELL_PRODUCT = '商品'

    exports.BUTTON_SHOP = 'ショッピングカート'

    exports.BUTTON_SELL_VIDEO_LAYOUT = '純粋なビデオテンプレート'

    exports.BUTTON_SELL_PPT_LAYOUT = 'PPTセールステンプレート'

    exports.BUTTON_HOMEWORK = '作業エリア'

    exports.BUTTON_CONFIRM_CANCEL_SCREEN_SHARE_BITRATE_CHANGE = '暂不处理'

    exports.BUTTON_CONFIRM_OK_SCREEN_SHARE_BITRATE_CHANGE = '再共有'

    exports.BUTTON_TOGGLE_VIDEO_AND_DOC = 'ウィンドウを切り替え'

    exports.BUTTON_MAIN_SCREEN_NOTICE = 'メインスクリーンの公告'

    exports.BUTTON_ASSISTANT_OPTIONS = '助教操作'

    exports.BUTTON_USER_AUTH_INFO = '表示権限'

    exports.BUTTON_REPORT = '報告'

    exports.BUTTON_REWARD_RANKING = 'ボーナスランキング'

    exports.BUTTON_RUSH_TO_ANSWER = '応答器'

    exports.BUTTON_TRANSFER_CLASS_START = '中継を開始する'

    exports.BUTTON_TRANSFER_CLASS_END = '中継を打ち切る'

    exports.BUTTON_GIFT_ANIMATION = 'プレゼント特効'

    exports.BUTTON_HIDE_GIFT_ANIMATION = 'シールドエフェクト'

    exports.BUTTON_SHOW_GIFT_ANIMATION = '特効を表示'

    exports.BUTTON_REWARDS = '賞をもらう'

    exports.BUTTON_REWARDS_STATISTICS = '収益統計'

    exports.BUTTON_LUCKY_BAG = '福袋'

    exports.BUTTON_CASH_WITHDRAW = '現金化'

    exports.BUTTON_VIDEO_LAYOUT = 'カスタムプッシュフロー'

    exports.BUTTON_ON_OFF_STAGE = '順番に壇上に上がる'

    exports.BUTTON_ACTIVITY = 'アクティビティ'

    exports.BUTTON_MESSAGE_CHECK = 'チャット審査'

    exports.BUTTON_TURN_OFF_ALL_USERS = '全員の音を切る'

    /**
     * =================================================
     * 标签
     * =================================================
     */

    exports.TAB_ALL_USER_LIST = 'ユーザー'

    exports.TAB_ACTIVE_USER_LIST = '投稿リスト'

    exports.TAB_CHAT = '雑談する'

    exports.TAB_ANSWER_LIST = '問答'

    exports.TAB_USER_LIST_HIDE = '人'

    exports.TAB_RESEARCH_GROUP = '研究グループ'

    exports.TAB_CLASS_STARTED = '生放送中'

    exports.TAB_TIME_SORT = '時刻ソート'

    exports.ANSWER_SORT_TYPE_SUBMIT = '送信時間でソート'

    exports.ANSWER_SORT_TYPE_OPERATE = '操作時間によるソート'

    /**
     * =================================================
     * 普通提示
     * =================================================
     */

    exports.INFO_CLASS_START = '授業ですよ'

    exports.INFO_CLASS_END = '授業が終わりました'

    exports.INFO_SPEAK_APPLY_TIMEOUT = '先生は長い間返事をしませんでした。自動的に手を挙げました。'

    exports.INFO_SPEAK_INVITE_TIMEOUT
        = '${userName}長い間応答していないか、古いクライアントを使って、自動的にキャンセルされました。'

    exports.INFO_SPEAK_OPEN_TIMEOUT
        = '${userName}長い間応答していないか、古いクライアントを使って、自動的に発言をキャンセルしました。'

    exports.INFO_SPEAK_OPEN_SUCCESS = '${userName}の発言を開いています。「発言リスト」で確認できます。'

    exports.INFO_HAS_BEEN_OPENED_SPEAKING = '先生はあなたの音声発言を手配しました。'

    exports.INFO_HAS_BEEN_OPENED_WEBMIC = '先生はもうあなたのマイクを開けました。'

    exports.INFO_HAS_BEEN_CLOSED_WEBMIC = '先生はマイクを閉じました。'

    exports.INFO_HAS_BEEN_OPENED_WEBCAM = '先生はもうあなたのカメラを開けました。'

    exports.INFO_HAS_BEEN_CLOSED_WEBCAM = '先生はもうあなたのカメラを閉じました。'

    exports.INFO_OPEN_WEBCAM_FAILED = 'ビデオのオープンに失敗しました。ボタンをクリックしてやり直してください。'

    exports.INFO_WEAR_EARPHONE_WHEN_SPEAKING = 'こだまや鳴き声をさけるために、イヤホンを着用してください。'

    exports.INFO_RECEIVE_MESSAGE = 'あなたは新しいニュースを持っています'

    exports.INFO_SPEAK_INVITE_ACCEPT = '${userName}発言を承諾した'

    exports.INFO_SPEAK_INVITE_REJECT = '${userName}発言を拒否しました'

    exports.INFO_SPEAK_APPLY_ACCEPT = '先生はあなたの発言を許可しました。'

    exports.INFO_SPEAK_APPLY_REJECT = '先生は手を挙げてもいいですか？後で試してみてください。'

    exports.INFO_END_SPEAK_BY_TEACHER = '先生はあなたの発言を終わりました。'

    exports.INFO_DEVICE_IS_STARTING = '音声ビデオのデバイスが起動中です。少々お待ちください。'

    exports.INFO_CAN_NOT_DO_BEFORE_END_SETTINGS = '設定が完了する前にこの操作ができません。'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_TEACHER = '最初にクラスボタンをクリックしてください'

    exports.INFO_CAN_NOT_OPEN_CAMERA_AND_MIC = '教師はカメラとマイクをオンにすることはできません'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_STUDENT = 'レッスンが開始されていません'

    exports.INFO_CAN_NOT_DO_BEFORE_APPLY = '発言はまず手を挙げてください'

    exports.INFO_NO_AVAILABLE_CAMERA = 'カメラがありません。'

    exports.INFO_NO_AVAILABLE_MIC = 'マイクがありません。'

    exports.INFO_FORBID_SEND_MESSAGE_TO_OPERATOR = 'チャットは禁止されています'

    exports.INFO_UNFORBID_SEND_MESSAGE_TO_OPERATOR = 'TAは禁止されました'

    exports.INFO_FORBID_SEND_MESSAGE_TO_TARGET = '先生はあなたのおしゃべりを禁止しました。'

    exports.INFO_FORBID_SEND_MESSAGE_END = '先生はもうあなたの禁止を解除しました。'

    exports.INFO_CLIENT_AUTO_UPGRADE
        = 'サポートされていない端末タイプは、最新バージョンのクライアントを使ってご覧ください。'

    exports.INFO_SURVEY_REPLY_RIGHT = 'おめでとうございます。正解です。'

    exports.INFO_SURVEY_REPLY_WRONG = 'あら、間違えました。'

    exports.INFO_SURVEY_REPLY_FREE = '本題に答えが設定されていません。'

    exports.INFO_SURVEY_NO_QUESTION = '“没有题干，可能老师是口述的”'

    exports.INFO_SURVEY_OPTION_HINT = '編集オプションをクリックします'

    exports.INFO_SURVEY_CHOOSE_OPTION = '<span class="arrow">↙</span>チェックをして正解を選ぶ'

    exports.INFO_SURVEY_SELF_CHOOSE = 'あなたの選択:'

    exports.INFO_COMMENT_SUCC = '成功を評価する'

    exports.INFO_COMMENT_BEFORE_CLASS = '少々お待ちください'

    exports.INFO_APPLY_SPEAK_WOULD_DELAY_SOUND
        = 'ウェブページのバージョンを使って発言すると、音が遅くなる可能性があります。'

    exports.INFO_SPEAK_INVITE_DENY = 'スポークスマンの数はすでにいっぱいです。後でやり直してください。'

    exports.INFO_MEDIA_PUBLISH_DENY = 'スポークスマンの数はすでにいっぱいです。後でやり直してください。'

    exports.INFO_CAN_NOT_CLOSE_CAMERA = '現在の回線は、ビデオをオフにする機能を提供していません'

    // exports.INFO_SWITCH_SERVER_SUCCESS = '已切换至 ${0}';

    exports.INFO_SWITCH_SERVER_SUCCESS = '切り替え済み'

    exports.INFO_FORBID_ALL = 'ぜんたいげんを停止した'

    exports.INFO_UNFORBID_ALL = '全禁を解除しました。'

    exports.INFO_FORBID_GROUP_ALL = 'このグループはすでに全員禁煙になった。'

    exports.INFO_UNFORBID_GROUP_ALL = 'このグループはすべての禁止をキャンセルしました'

    exports.INFO_SELF_ABROAD_TIPS
        = '海外で授業を受けていることが検出された場合、国際ネットワークの安定性が保証されない場合があります。<br/>'
        + '中国へのアクセス速度が正常であることを確認してください。'

    exports.INFO_TEACHER_ABROAD_TIPS
        = '先生が海外で授業をしているのを発見しました。<br/>'
        + '音声映像は不安定な問題があるかもしれませんので、ご了承ください。'

    exports.INFO_OPEN_CAMERA = '${userRole}カメラを開けて、データをバッファしています。'

    exports.INFO_OPEN_ASSIST_CAMERA = '${userRole}補助カメラの電源を入れます。データはバッファリングされています'

    exports.INFO_CLOSE_CAMERA = 'カメラを閉じる'

    exports.INFO_OPEN_MIC = '${userRole}マイクロフォンを開けて、データはバッファしています。'

    exports.INFO_CLOSE_MIC = 'マイクを閉じる'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_SHARE_PLAY
        = 'まずスクリーン共有とプレーヤーを閉じて、第三者ストリームの転送を停止してください。'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CLOUD_RECORD
        = 'クラウド録画授業ではアップリンクのタイプを切り替えてはいけません。'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = 'ハイビジョン、超清、1080 pモードでは顔を開けられません。'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = 'ハイビジョン、超清、720 p、1080 pモードでは、美顔を開けられません。'

    exports.INFO_CLOUD_RECORD_START = 'クラウド録音を開始しました。'

    exports.INFO_CLOUD_RECORD_STOP = 'クラウドの録音を停止しました。'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_THIRD_PUSH = 'スクリーンを共有する前に、転送を停止してください。'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_PLAY_FILE = '画面を共有する前に、ファイルの再生を停止してください'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_SCREEN_SHARE = 'ファイルを再生する前に、画面共有を停止してください'

    exports.CONFIRM_STOP_ASSIST_CAMERA_BEFORE_MEDIA_PLAY
        = '<b>メディア再生を開始しますか？</b>メディア再生をオンにすると、サブカメラがオフになります。'

    exports.CONFIRM_STOP_MEDIA_PLAY_BEFORE_OPEN_ASSIST_CAMERA
        = '<b>補助カメラをオンにしますか？</b>サブカメラをオンにすると、メディアの再生をオフにします。'

    exports.INFO_PLAY_LOCAL_MEDIA_FILE = 'ローカルファイルを再生'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_THIRD_PUSH
        = 'ローカルファイルを再生する前に、転送を停止してください。'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SCREEN_SHARE
        = 'サードパーティを転送する前に、スクリーンを停止して共有してください。'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_WHEN_COLLECT_SYSTEM_SOUND
        = 'システム音の収集を開始したらローカルファイルを再生できません。'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_COLLECT_SYSTEM_SOUND
        = 'まずシステム音の収集をキャンセルしてください。'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_PLAY_LOCAL_MEDIA_FILE
        = 'まずローカルファイルを閉じて再生してください。'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_MEDIA_FILE_PLAY
        = 'ローカルファイルの再生を開始した後、システムサウンドを収集できません'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SHARE_DESKTOP
        = 'サードパーティを転送する前に、スクリーンを停止して共有してください。'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START
        = '再生を生成していますが、この時間はクラウドでの録画を継続できません。'

        exports.INFO_CLOUD_RECORD_START_COUNT_WARNING = '頻繁に一時停止すると再生品質に影響が出る可能性があります。しばらくしてからもう一度お試しください。'

    exports.INFO_GET_PLAYBACK_STATUS_FAIL = '再生生成ステータスを取得できませんでした。再試行してください'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP
        = '<p class="large">再生を開始しますか？</p> <p class="error">（再生開始後はクラウドでの録画はできません）</p>'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP_LONG_TERM = '<p class="large">再生を開始しますか？</p>'

    exports.INFO_SEND_IMAGE_POST_DATA_ERROR = 'データ解析エラー'

    exports.INFO_CAN_NOT_DETECT_DEVICE_DURING_SPEAKING = 'システム検出前に発言を中止してください。'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CONSISTENSY
        = 'リンクタイプは一律に設定されているため、この設定は有効になりません'

    exports.INFO_CLOSE_BARRAGE_TIP = 'ペンを使用する必要がある場合は、最初に弾幕機能をオフにしてください'

    exports.INFO_SETTING_FORBID_BY_CLASS_STARTED = '授業中はこの設定を変更できませんでした。'

    exports.INFO_RTMP_NOT_RUNNING = '先生が押してくれませんでした'

    exports.INFO_HAS_FORBID_MIC = 'すべての人のマイクを閉じました。'

    exports.INFO_HAS_BEEN_MUTED = '先生は全員のマイクを閉じました。'

    exports.INFO_MESSAGE_COPY_SUCCESS = 'チャット内容のコピーに成功しました。'

    exports.INFO_QA_COPY_SUCCESS = 'Q＆Aコンテンツが正常にコピーされました'

    exports.INFO_QA_COPY_FAIL = 'クイズ内容のコピーに失敗しました。手動でコピーしてください。'

    exports.INFO_PLAYER_PAUSE_BY_MIC_OFF = 'ファイルの再生を続行するには、マイクをオンにしてください'

    exports.INFO_USER_ACTIVE_ADD_DENY
        = 'スピーカーの数がいっぱいです。最初に他の学生のオーディオとビデオをオフにしてください。'

    exports.INFO_ENROLL_START = '申し込みをしました'

    exports.CLASSROOM_COUNTDOWN_TITLE = '生放送開始までまだあります'

    exports.INFO_GIFT_ANIMATION_ENABLE = 'プレゼントの特効が開きました'

    exports.INFO_GIFT_ANIMATION_DISABLE = 'プレゼント特殊効果は閉鎖されました'

    exports.INFO_NO_CAMERA_OPERATION_PERMISSION = 'カメラ操作権限がありません'

    /**
     * =================================================
     * 空状态提示
     * =================================================
     */
    exports.INFO_NO_SPEAKER = '誰も話していません'

    /**
     * =================================================
     * 警告提示
     * =================================================
     */

    exports.WARNING_INPUT_FREQUENT = '画面を消さないでください'

    exports.WARNING_INPUT_EMPTY = 'チャットの内容を入力してください。'

    exports.WARNING_INPUT_OVERLENGTH = 'あまり長い内容は入力しないでください。'

    exports.WARNING_CAMERA_SWITCH_FREQUENT = 'カメラを頻繁に切り替えないでください'

    exports.WARNING_MIC_SWITCH_FREQUENT = 'マイクを頻繁に切り替えないでください'

    exports.WARNING_CLOSE_DIALOG_ON_DOCUMENT_UPLOADING
        = 'コースウェアがアップロードされています。しばらくお待ちください'

    exports.WARNING_SEND_MESSAGE_FORBID = 'あなたはチャットを禁止されています'

    exports.WARNING_SURVEY_OPTION_HINT = 'シリアル番号の文字をクリックして、正解を設定してください'

    exports.WARNING_SURVEY_TEXTAREA_MAX = '質問には100語を超えないでください！'

    exports.WARNING_SURVEY_OPTION_MAX = '25語以内でお願いします！'

    exports.WARNING_VOLUME_OVERFLOW = '倍率が高すぎると歪むことがあります'

    exports.WARNING_COMMENT_TEXT_HINT = '入力することもできます'

    exports.WARNING_COMMENT_TEXT_UNIT = '語'

    exports.WARING_COMMENT_NO_TEXT = '先生に対する評価を入力してください。'

    exports.WARING_COMMENT_NO_CONTENT = '先生の全体的な評価を入力してください。'

    exports.WARING_COMMENT_UPLOAD_FULL = '最大5枚の写真を追加'

    exports.WARNING_SWITCH_CDN_SERVER
        = '先生が回線を切り替えると、すべての生徒が自動的に教室に再入室します。切り替えてもよろしいですか？'

    exports.WARNING_ABROAD_CONFIRM = 'とった'

    exports.WARNING_ABRAOD_TIPS = 'リマインダ'

    exports.WARING_PLAY_FILE_FAILED
        = 'ファイルの再生に失敗しました。サポートされていないファイルタイプやビデオは削除されました。'

    exports.WARING_PLAY_FILE_LENGTH_FAILED = '少なくとも1 s以上の音声/ビデオファイルをアップロードしてください。'

    exports.WARN_WEBRTC_MEDIA_DEVICE_PERMISSON_DENY
        = '${authType}の開始に失敗しました。${deviceType}へのアクセスを許可してください'

    exports.WARN_NO_AUTH_QUIZ = '試験の権限を無効にしました。'

    exports.WARN_NO_AUTH_ANSWER = 'フラッシュのパーミッションを無効にしました。'

    exports.RISK_ASSESSMENT = 'リスクアセスメント'

    /**
     * =================================================
     * 成功提示
     * =================================================
     */

    exports.SUCCESS_UPLOAD_DOCUMENT = 'アップロードが成功しました。トランスコードの中でしばらくお待ちください。'

    exports.SUCCESS_DETECT_CAMERA = 'カメラデバイスが正常に検出されました'

    exports.SUCCESS_DETECT_ASSIST_CAMERA = '補助カメラデバイスが正常に検出されました'

    exports.FAIL_DETECT_ASSIST_CAMERA = 'サブカメラデバイスが検出されていません。'

    /**
     * =================================================
     * 错误提示
     * =================================================
     */

    exports.ERROR_RECORD_FAIL_ON_PATH_NOT_EXIST = '存在しないため、コースの記録を続行できません'

    exports.ERROR_RECORD_FAIL_ON_DISK_NOT_ENOUGH = 'ディスク容量が不足しているため、コースの記録を続行できません'

    exports.ERROR_UPLOAD_DOCUMENT = 'アップロードに失敗しました'

    exports.ERROR_DOCUMENT_TYPE_NOT_SUPPORT
        = 'ファイルフォーマットが間違っています。word、ppt、pdfまたは画像フォーマットの授業をアップロードしてください。'

    exports.ERROR_DOCUMENT_SIZE_NOT_SUPPORT = '50m未満のファイルをアップロードしてください'

    exports.ERROR_DOCUMENT_NAME = 'ファイル名に句読点が含まれています。アップロードする前にファイル名を変更してください'

    exports.ERROR_GET_GIFT_PAY_URL = '配達に失敗しました。もう一度試してみます。'

    exports.ERROR_RUN_CEF_FAIL = 'クライアントの初期化に失敗しました。クライアントを再起動してください。'

    exports.ERROR_NOT_SURPORT_SELL_TEMPLATE = 'pcはサポートされていません。h 5を通じて入ってください。'

    /**
     * =================================================
     * 邀请函
     * =================================================
     */

    exports.ENTER_CLASSROOM_BY_JOIN_CODE = '参加コード方式'

    exports.ENTER_CLASSROOM_WITH_SECRET = 'app暗号方式'

    exports.JOIN_CODE = '参加コード'

    exports.JOIN_CODE_SPECIFICATION = '参加コードの使用説明'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_DAYS = '空 '

    // 为了使倒计时的时间数字和量词之间不会挨在一起，要在‘时’和‘分’后加一个空格
    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_HOURS = '時刻 '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_MINUTES = 'ポイント '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_SECONDS = '秒'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TITLE = 'ヒント'

    exports.CLASS_START_TIME = '開始時間'

    exports.TEACH_DURATION = '授業時間は長いです'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_LABEL = '本当の名前を入力してください:'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TIP = '入力は空にできません'

    exports.INVITATION_TITILE_HINT = 'ヒント'

    exports.INVITATION_TIP_OPENING_CLIENT = 'クライアントを開くことを試みています。'

    exports.INVITATION_BUTTON_DOWNLOAD_CLIENT = 'クライアントをダウンロード'

    exports.INVITATION_BUTTON_ENTER_CLASSROOM_VIA_WEB = '教室に入る'

    exports.INVITATION_LABEL_OTHER_METHOD_ENTER_CLASSROOM = 'その他の教室方式'

    exports.INVITATION_TIP_ADVICE_DOWNLOAD_CLIENT
        = 'クライアントがインストールされていないか、または開けられない場合は、最新のクライアントをダウンロードしてください。'

    /**
     * =================================================
     * 倒计时
     * =================================================
     */

    exports.CLASSROOM_ENTER_COUNT_DOWN_TIP = 'ええと.. ${preEnterTimeText}は開始前に部屋に入ることができます'

    exports.CLASS_EXPIRE_TIP = 'この生放送はもう終わりました。'

    exports.CLASS_DELETED_TIP = 'この生放送はキャンセルされました。'

    exports.CLASSROOM_ENTER_TIP_STRING_DAYS = '空'

    exports.CLASSROOM_ENTER_TIP_STRING_HOURS = '時間'

    exports.CLASSROOM_ENTER_TIP_STRING_MINUTES = '分'

    exports.CLASSROOM_ENTER_TIP_STRING_SECONDS = '秒'

    exports.BUTTON_ENTER = 'ライブルームに入る'

    /**
     * =================================================
     * 试听课
     * =================================================
     */
    exports.TRIAL_START_TIP
        = '${leftMinutes}分間聞いてみてください。ライブ放送全体を見るには、<spanclass="enroll">今すぐ登録</span>してください。'

    exports.TRIAL_END_TIP
        = 'この授業の試聴はもうすぐ終わります。先生の話がいいと思います。<span class="enroll">早速申し込みます</span>でしょう'

    exports.COURSE_ENROLL_HREF = '早速申し込みます'

    exports.FORBIDDEN_BTN_TIP = '申し込みしてから先生と交流できますよ。'

    exports.TRIAL_LEAVE_NOTICE = 'オーディション課の教室を離れますか？'

    /**
     * =================================================
     * 确认
     * =================================================
     */

    exports.CONFIRM_END_CLASS = '授業が終わるのを確認しますか？'

    exports.CONFIRM_END_SPEAK = '発言を終了することを確認しますか？'

    exports.CONFIRM_END_WARMING_UP = '暖場は確実に終わりますか？'

    exports.CONFIRM_STOP_RECORD = '録画レッスンを中止することを確認しますか？'

    exports.CONFIRM_STOP_SCREEN_SHARE = '共有デスクトップを停止しますか？'

    exports.CONFIRM_SWITCH_LINK_TYPE = 'あなたのネットワークは不安定です。リンクタイプの解決を切り替えてみますか？'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_CLOSE_CAMERA
        = 'カメラをオフにすると共有デスクトップを停止します。閉じることを確認しますか？'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_OPEN_CAMERA
        = 'カメラを開けば共有デスクトップを停止します。開けて確認しますか？'

    exports.CONFIRM_RELOAD_ON_WEBSOCKET_CLOSE_BJY
        = 'ネットを切ったようです。早くインターネットをチェックして、もう一度試してみてください。'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_SCREEN_SHARE = '共有デスクトップはまずカメラを開けなければならないですか？'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_PLAY_MEDIA
        = 'ローカルオーディオビデオファイルを再生するには、まずカメラを開けなければなりませんか？'

    exports.CONFIRM_UPGRADE_BEFORE_USE
        = '現在のクライアントのバージョンが低いので、先生の音声ビデオを正常に受信できません。最新のクライアントをアップグレードしてください。'

    exports.CONFIRM_UPGRADE_HINT
        = '現在のクライアントのバージョンが低すぎます。更新ボタンをクリックして最新のクライアントをダウンロードしてください。<br />より豊かな機能を体験する'

    exports.CONFIRM_EXIT_CLASSROOM = '生中継室を離れるかどうか？'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLASS = '授業中に教室を離れると自動的に授業が終わります。'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLOUD_RECORD
        = '授業の録音中は、教室を離れて自動的に授業が終わり、雲の中で録音が停止されます。'

    exports.CONFIRM_USE_CAMERA_ON_NO_AVAILABLE_CAMERA = '利用可能なカメラが検出されませんでした。カメラを使いますか？'

    exports.CONFIRM_USE_MIC_ON_NO_AVAILABLE_MIC = '利用可能なマイクが検出されませんでした。マイクを使いますか？'

    exports.CONFRIM_FORBID_USER_SEND_MESSAGE = '確認はtaチャットを禁止しますか？'

    exports.CONFIRM_REMOVE_DOCUMENT = 'この授業を削除しますか？'

    exports.CONFIRM_REMOVE_HOMEWORK = '作業を削除することを確認しますか？'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_CAMERA
        = '利用可能なカメラデバイスが検出されませんでした。再検出しますか？'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_ASSIST_CAMERA
        = '利用可能なサブカメラデバイスが検出されませんでした。再検出しますか？'

    exports.CONFIRM_PURCHASE = 'まだ授業を申し込んでいません。まず名前を教えてください。'

    exports.CONFIRM_TO_TCP_LINK
        = 'tcpの上り方向を切り替えると学生の声が録音できなくなりますが、切り替えを確認しますか？'

    exports.CONFIRM_END_RTMP_PUSH = '先生の推流を中止することを確認しますか？'

    exports.CONFIRM_SCREEN_SHARE_BITRATE_CHANGE
        = '生放送のスクリーンシェアが変更されました。再共有をクリックしてから有効にしてください。'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_TITLE = 'タブレットを接続する'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_CONTENT
        = 'タブレットの接続に失敗しました。再接続してください。<br>「外付け手書き」が開いており、通信範囲内であることを確認してください。'

    exports.CONFIRM_BUTTON_CONNECT_HAND_WRITTING_BOARD = '再接続'

    exports.CONFIRM_PIP_ERR = '初期化では、[OK]をクリックして[顔を出す]機能を有効にしてください'

    exports.CONFIRM_TURN_OFF_ALL_USERS = '全員の音声を閉じますか？'

    /**
     * =================================================
     * Tooltip
     * =================================================
     */

    exports.TOOLTIP_LASER = 'レーザー？ペン'

    exports.TOOLTIP_MOVE = '移動'

    exports.TOOLTIP_DOODLE = '絵筆'

    exports.TOOLTIP_TEXT = 'テキスト'

    exports.TOOLTIP_ARROW = '矢印'

    exports.TOOLTIP_RECT = '長方形'

    exports.TOOLTIP_ERASER = 'クリア'

    exports.TOOLTIP_CLEAR = '空をクリア'

    exports.TOOLTIP_SMILE = 'ほほえむ'

    exports.TOOLTIP_GIGGLE = '馬鹿笑い'

    exports.TOOLTIP_PROUD = '得意になる'

    exports.TOOLTIP_NAUGHTY = 'やんちゃを言う'

    exports.TOOLTIP_EXHAUSTED = '眠いです'

    exports.TOOLTIP_CRY = '大声で泣く'

    exports.TOOLTIP_EMBARRASSED = '口をそぐ'

    exports.TOOLTIP_DOUBT = '疑問'

    exports.TOOLTIP_APPEARANCE = '色'

    exports.TOOLTIP_POWERFUL = 'すごいです'

    exports.TOOLTIP_WORSHIP = '崇拝'

    exports.TOOLTIP_STRUGGLE = '戦いを挑む'

    exports.TOOLTIP_WEIGHS = '目が回る'

    exports.TOOLTIP_SURPRISE = '驚きいぶかる'

    exports.TOOLTIP_SPEECHLESS = '言葉なし'

    exports.TOOLTIP_HEARTSTOPPER = '衰える'

    /**
     * =================================================
     * 对话框
     * =================================================
     */

    exports.DIALOG_MANAGE_DOCUMENT = 'ファイルを選択'

    exports.DIALOG_MANAGE_HOMEWORK = '作業エリア'

    exports.DIALOG_DEBUG = 'デバッグ情報'

    exports.USER_DIALOG_DEBUG = 'レッスン情報'

    exports.ALERT_DEFAULT_TITLE = 'ヒント'

    exports.DIALOG_QUESTION_ANSWER = '問答'

    exports.DIALOG_DEBUG_PANEL = 'デバッグパネル'

    exports.DIALOG_MESSAGE_BOX_PUBLIC = 'チャット'

    exports.DIALOG_MESSAGE_BOX_RESEARCH = '教学研究グループ'

    exports.DIALOG_MESSAGE_BOX_WHISPER = 'チャット-{user-name}とプライベートにチャットする'

    exports.DIALOG_USER_AUTH_TITLE = '友情のヒント'

    exports.MORE_BUTTON_TITLE = '詳細機能'

    exports.MORE_BUTTON_TITLE_EDIT = '編集'

    exports.DIALOG_REPORT_TITLE = '通報理由を選択してください'

    /**
     * =================================================
     * 空文本占位符
     * =================================================
     */

    exports.PLACEHOLDER_NOTICE_FOR_WRITER = 'ここでクラスの発表ができます。'

    exports.PLACEHOLDER_NOTICE_GROUP_FOR_WRITER = 'ここでグループ内の通知を発表してもいいです。'

    exports.PLACEHOLDER_NOTICE_FOR_READER = '掲示板は空き…'

    exports.PLACEHOLDER_INPUT_AMOUNT = '金額を入力してください'

    exports.PLACEHOLDER_COMMENT_FOR_SEND = '先生に対する評価を書きましょう。'

    /**
     * =================================================
     * 一些杂七杂八的话术
     * =================================================
     */

    exports.LABEL_RECORDING = '録音'

    exports.LABEL_WECHAT_HELP = 'wechatで助けを求める'

    exports.LABEL_STUDENT_JOIN_CLASS_NO = '学生は教室に入っていません'

    exports.LABEL_STUDENT_JOIN_CLASS_YES = '学生は教室に入りました。'

    exports.LABEL_FAIL_AGAIN = '失敗しましたか'

    exports.LABEL_CONTACT_TEL = '電話可能：400-910-910-910'

    exports.LABEL_CONTACT_QQ = 'または技術サポートqqを追加します。'

    exports.LABEL_CLASSROOM_ID_TEXT = '教室のid'

    exports.LABEL_TOUCH_SCREEN_SUPPERT = 'タッチパネルサポート'

    exports.LABEL_VIDEO_POPUP_TO_AUX_SCREEN = '動画を補助画面に表示します。'

    exports.LABEL_REPAIR_PROGRAM_SHARE = '修復プログラム共有ブラックスクリーン'

    exports.LABEL_MEDIA_PANEL = 'ユーザーエリア'

    exports.LABEL_MESSAGE_PANEL = 'テキスト'

    exports.LABEL_LOADING = '読み込み中..'

    exports.LABEL_DATA_LOADING = 'データの読み込み中です。少々お待ちください。'

    exports.LABEL_VIDEO = '動画リスト'

    exports.LABEL_AUDIO = 'オーディオ'

    exports.LABEL_AUDIO_AND_VIDEO = '動画リスト'

    exports.LABEL_WHITEBOARD = '白い板'

    exports.LABEL_CAMERA = 'カメラ'

    exports.LABEL_MIC = 'マイク'

    exports.LABEL_MIC_AND_CAMERA = 'マイクとカメラ'

    exports.LABEL_SPEAKER = 'スピーカー'

    exports.LABEL_RECORD = 'レッスンの録音'

    exports.LABEL_SHARE = 'スクリーン共有'

    exports.LABEL_CLASS_SETTING = 'ルームコントロール'

    exports.LABEL_OTHER = 'その他'

    exports.LABEL_DEVICE_LIST = 'デバイスリスト'

    exports.LABEL_AUDIO_REPAIR = 'チャンネルの修復'

    exports.LABEL_AUDIO_REPAIR_NO = '修復は不要です'

    exports.LABEL_AUDIO_REPAIR_LEFT = '左チャンネルを修復'

    exports.LABEL_AUDIO_REPAIR_RIGHT = '右チャンネルを修復'

    exports.LABEL_INPUT_VOLUME = '音量を入力'

    exports.LABEL_OUTPUT_VOLUME = '出力音量'

    exports.LABEL_AGC = '自動ゲイン'

    exports.LABEL_POPUP = 'イジェクト'

    exports.LABEL_CLOSE = '閉じる'

    exports.LAEBL_CLOSE_MIC = '発言を打ち切る'

    exports.LABEL_PRIMARY_CAMERA_SETTING = 'メインカメラの設定'

    exports.LABEL_MINOR_CAMERA_SETTING = 'サブカメラの設定'

    exports.LABEL_NO_AVAILABLE_CAMERA = 'カメラがありません。'

    exports.LABEL_NO_AVAILABLE_MIC = 'マイクがありません。'

    exports.LABEL_NO_AVAILABLE_SPEAKER = 'スピーカーがありません。'

    exports.LABEL_VIDEO_QUALITY = '動画の品質'

    exports.LABEL_CAN_YOU_HEAR_YOUR_VOICE = 'ヒント：話をしてください。自分の声が聞こえますか？'

    exports.LABEL_APPLY_BEFORE_SPEAK = '発言はまず手を挙げてください'

    exports.LABEL_WAIT_TEACHER_ACCEPT = '先生の同意を待ってください。'

    exports.LABEL_SPEAK_APPLYING = '手を挙げる'

    exports.LABEL_TEACHER_SPEAK_INVITING = '先生があなたを麦に招待して発言します。'

    exports.LABEL_DOCUMENT_IN_LIBRARY = 'データベース'

    exports.LABEL_DOCUMENT_IN_USE = '展示授業'

    exports.LABEL_DOCUMENT_TYPE_HINT = 'wps編集した文書はpdfに変換してアップロードしてください。'

    exports.LABEL_DOCUMENT_HELP_LINK = 'この点をクリックして変換教程を表示します。'

    exports.LABEL_PAGE_LOADING = '授業の読み込み中..'

    exports.LABEL_DOCUMENT_TRANSFORMING = '文書の変換を頑張っています。少々お待ちください。'

    exports.LABEL_DOCUMENT_TRANSFORMING_TIP = 'トランスコードで…'

    exports.LABEL_DOCUMENT_TRANSFORM_COMPLETE_TIP = 'トランスコード完了'

    exports.LABEL_DOCUMENT_TRANSFORM_FAIL = '文書の変換に失敗しました。もう一度アップロードしてください。'

    exports.LABEL_CLASS_DOCUMENT = '私の授業'

    exports.lABEL_USER_DOCUMENT = '学生の写真'

    exports.LABEL_UPLINK_BANDWIDTH = '上り帯域幅'

    exports.LABEL_DOWNLINK_BANDWIDTH = '下り帯域幅'

    exports.LABEL_FORBID_ALL_REMINDER = '生徒全員禁煙中'

    exports.LABEL_SEND_GIFT_PAY_TITLE = '先生、ありがとうございます。'

    exports.LABEL_LOADING_TIMEOUT = '教室に入れませんか？呼び出し助け400-910-910'

    exports.LABEL_SURVEY_QUESTION = 'タイトル:'

    exports.LABEL_SURVEY_MULTIPLE_ANSWER = '複数選択'

    exports.LABEL_SURVEY_SEND_TITLE = '問題を出す'

    exports.LABEL_SURVEY_REPLY_TITLE = 'クイズ'

    exports.LABEL_SURVEY_REPLY_RESULT = 'クイズの結果'

    exports.LABEL_SURVEY_MYCHOICE = 'あなたの選択'

    exports.LABEL_SURVEY_RIGHT_COUNT = '正解'

    exports.LABEL_SURVEY_WRONG_COUNT = '答えを誤る'

    exports.LABEL_SURVEY_OPTION_UNIT = '人'

    exports.LABEL_SURVEY_TITLE_NAME = 'フラッシュカード'

    exports.LABEL_GIFT_TYPE_ORANGE_JUICE = 'オレンジ？ジュース'

    exports.LABEL_GIFT_TYPE_ICE_TEA = 'アイスティー'

    exports.LABEL_GIFT_TYPE_BARLEY_TEA = '麦茶'

    exports.LABEL_RECORDING_INDICATOR = '先生は授業中です'

    exports.LABEL_RECORDING_LOCAL = 'ローカル'

    exports.LABEL_RECORDING_CLOUD = '雲の端'

    exports.LABEL_RECORDING_PUSH = 'スクリーンショット'

    exports.LABEL_RECORDING_SUFFIX = '録音中'

    exports.LABEL_DOC_QUALITY_HIGH = '原図'

    exports.LABEL_DOC_QUALITY_LOW = '滑らかである'

    exports.LABEL_DOC_FIT_WIDTH = '塗りつぶし'

    exports.LABEL_DOC_FIT_VIEW = '順応する'

    exports.LABEL_COMMENT_REMIND_TITLE = '今回のレッスンを評価します'

    exports.LABEL_COMMENT_POINT_UNIT = 'ポイント'

    exports.LABEL_COMMENT_TEACHER_TITLE = '私の評価'

    exports.LABEL_COMMENT_TYPE_TOTAL = '全部'

    exports.LABEL_COMMENT_TYPE_GREAT = '好評'

    exports.LABEL_COMMENT_TYPE_MIDDLE = '評定に当たる'

    exports.LABEL_COMMENT_TYPE_LOWER = '評判が悪い'

    exports.LABEL_COMMENT_MAX_LENGHT = '200文字'

    exports.LABEL_COMMENT_TOTAL_RATER = '全般的な評価'

    exports.LABEL_COMMENT_ANONYMOUS = '匿名の評価'

    exports.LABEL_COMMENT_REMARK = '評価'

    exports.LABEL_COMMENT_POINT_FIVE = '五つの星'

    exports.LABEL_COMMENT_POINT_FOUR = '四星'

    exports.LABEL_COMMENT_POINT_THREE = '三つ星'

    exports.LABEL_COMMENT_POINT_TWO = '二星'

    exports.LABEL_COMMENT_POINT_ONE = '星一つ'

    exports.LABEL_COMMENT_UNIT_TIPS = '合計${totalCount}'

    exports.LABEL_COMMENT_TYPE = '学習の評価'

    exports.LABEL_BEAUTIFY_AND_DENOISE = '美顔ノイズ低減'

    exports.LABEL_SETTINGS = '設定'

    exports.LABEL_AUTH_MANAGEMENT = '権限管理'

    exports.LABEL_EYE_PROTECTION = 'アイモード'

    exports.LABEL_SCREENSHOT = 'スクリーン'

    exports.LABEL_SCREENSHOT_WITH_ROOM_HIDED = '教室のスクリーンショットを隠す'

    exports.LABEL_POSITION = '場所${number}'

    exports.LABEL_DETECT_TOOL = 'システム検出'

    exports.LABEL_FORBID_ALL = '全員禁言'

    exports.LABEL_SHARE_POSITION = 'スクリーン共有画像の表示位置'

    exports.LABEL_SHARE_POSITION_MOD_TIP = '後で設定に変更できます。'

    exports.LABEL_NUMBER_ONE = '1つ'

    exports.LABEL_NUMBER_TWO = '二番目'

    exports.LABEL_NUMBER_THREE = '三番目'

    exports.LABEL_NUMBER_FOUR = '四番目'

    exports.LABEL_NUMBER_FIVE = '5'

    exports.LABEL_NUMBER_SIX = '六'

    exports.LABEL_NUMBER_SEVEN = '7'

    exports.LABEL_NUMBER_EIGHT = '8'

    exports.LABEL_NUMBER_NINE = '9'

    exports.LABEL_NUMBER_TEN = '10'

    exports.LABEL_SERVER_ROUTE = '行${number}'

    exports.LABEL_OTHER_SERVER_ROUTE = 'その他の路線'

    exports.LABEL_CDN_ROUTE_PRIMARY = '主'

    exports.LABEL_CDN_ROUTE_ASSISTANT = '副'

    exports.LABEL_CHECK_ALL = 'すべて選択'

    exports.LABEL_UNIT = '個'

    exports.LABEL_LINK_TYPE = 'リンクの種類'

    exports.LABEL_UPLINK = '上り'

    exports.LABEL_DOWNLINK = '下り'

    exports.LABEL_tcp = 'tcp'

    exports.LABEL_udp = 'udp'

    exports.LABEL_TEACHER = '先生'

    exports.LABEL_NICKNAME = 'ニックネーム'

    exports.LABEL_DON_NOT_REMIND_ANY_MORE = '今度は注意しない'

    exports.LABEL_GIFT_PAY_HINT = '支払い方法'

    exports.LABEL_GIFT_WECHAT = 'wechat'

    exports.LABEL_GIFT_ALIPAY = 'アリペイを支払う'

    exports.LABEL_COMMENT_RECEIVE_TITLE = '評価リスト'

    exports.LABEL_COMMENT_SEND_TITLE = '今回のレッスンを評価します'

    exports.LABEL_LOTTERY_SEND_TITLE = '賞品を与える'

    exports.LABEL_LOTTERY_SEND_HEADER = '"今回のサプライズは何ですか？"'

    exports.LABEL_LOTTERY_SEND_NAME = '賞品の名前'

    exports.LABEL_LOTTERY_SEND_NUMBER = '賞品の部数'

    exports.LABEL_CURRENT_STUDENT_COUNT = '現在の教室の学生${userCount}人'

    exports.LABEL_LOTTERY_SEND_HINT
        = '賞品を当たった学生は換金コードをもらうことができる。<br/>景品の交換は先生自ら学生に連絡してください。'

    exports.LABEL_LOTTERY_DRAW_HINT = '先生は宝くじを通じて賞品を配ります。'

    exports.LABEL_LOTTERY_SEND_BTN = 'プレゼントを送る'

    exports.LABEL_LOTTERY_UNIT = '盛り付け'

    exports.LABEL_LOTTERY_REMAIN = 'まだ残っています'

    exports.LABEL_LOTTERY_SAVE_LIST = 'リストを保存'

    exports.LABEL_LOTTERY_DRAW_TIP = 'プレゼントを送りました'

    exports.LANEL_LOTTERY_DRAW_BTN = '祝儀を解く'

    exports.LABEL_LOTTERY_DRAW_SUCC = 'おめでとうございます当選しました'

    exports.LABEL_LOTTERY_DRAW_CODE = '換金コード'

    exports.LABEL_LOTTERY_SHOW_WINNERS = 'みんなの様子を見てください'

    exports.LABEL_LOTTERY_DRAW_FAIL = '手が遅くなりました。お年玉のパイが終わりました。'

    exports.LABEL_LOTTERY_REDPACK = '祝儀袋'

    exports.LABEL_OF_UNITE = 'の'

    exports.LABEL_INPUT_LOTTERY_NAME = '賞品の名前を入力してください。'

    exports.LABEL_INPUT_LOTTERY_NUMBER_ERROR = '正しい賞品の数量を入力してください。'

    exports.LABEL_INPUT_LOTTERY_OVER_MEMBER = '賞品の数量は学生の人数より大きくしてはいけません。'

    exports.LABEL_INPUT_LOTTERY_OVER_MAX = '賞品の数量は50個以上はできません。'

    exports.LABEL_CAMERA_PIXEL_RATIO = '動画リスト'

    exports.LABEL_CAMERA_SETTING = '動画の設定'

    exports.LABEL_CAMERA_FLIP_HORIZONTAL = '水平方向に反転'

    exports.LABEL_CAMERA_FLIP_VERTICAL = '垂直方向に反転'

    exports.LABEL_CAMERA_CROP = '画面カッティング'

    exports.LABEL_CAMERA_DISENABLE = '有効にしない'

    exports.LABEL_TIP_CLICK_BTN_START_CLASS = 'ボタンをクリックして授業を開始します。'

    exports.LABEL_UPDATE_OLD_CLIENT_VERSION
        = '現在のクライアントのバージョンは低すぎます。最新版にアップグレードしてください。'

    exports.LABEL_UPDATE_CLIENT_VERSION = '最新のクライアントをダウンロードします。'

    exports.LABEL_CLOSE_CLIENT = 'クライアントを閉じる'

    exports.LABEL_CLIENT_INVITE_CODE = 'クライアント招待コード'

    exports.LABEL_WEB_LINK = 'ウェブリンク'

    exports.LABEL_REFRESH_WAITED = '更新中です。少々お待ちください。'

    exports.LABEL_SHAREING_NO_OPTION = 'スクリーン共有では、この操作はサポートされていません。'

    exports.LABEL_WHISPER_TITLE = '私的な話'

    exports.LABEL_BARRAGE = '弾幕'

    exports.LABEL_LOCK_SCREEN = '学生の鍵'

    exports.LABEL_RAISE_HAND = '手を挙げる'

    exports.LABEL_APPLY_SPEAK = '発言を求める'

    exports.LABEL_SAVE_SUCCESS = '保存に成功しました！'

    /**
     * =================================================
     * 求助
     * =================================================
     */

    exports.BUTTON_CUSTOM_SERVICE_QQ = 'qq助けを求めます'

    exports.BUTTON_CUSTOM_SERVICE_TECHNICAL = '技術援助'

    exports.BUTTON_CUSTOM_SERVICE_CLASS_INFO = 'レッスン情報'

    exports.DIALOG_TITLE_TECH_HELP = '技術援助'

    exports.BUTTON_CUSTOM_SERVICE_WECHAT = 'wechatで助けを求める'

    exports.BUTTON_CUSTOM_SERVICE_OFFICIAL = '公式サイトで助けを求めます'

    exports.TITLE_HELP_TYPE = 'ヘルプのタイプ'

    exports.TITLE_CONTACT_WAY = '連絡先'

    exports.TYPE_VIDEO_LAG = '動画リスト'

    exports.TYPE_CLIENT_CRASH = 'システム崩壊'

    exports.TYPE_OTHER = 'その他'

    exports.CONTACT_TYPE_qq = 'qq'

    exports.CONTACT_TYPE_PHONE = '電話'

    exports.PLACEHOLDER_DESCRIPTION = 'ヘルプの説明を入力してください。'

    exports.INFO_CREATE_HELP_SUCCESS = '技術援助はすでに関連の先生に発送しました。後で連絡します。'

    exports.UNKNOW_ERROR = '未知のエラーが発生しました。'

    exports.WARING_INVALID_PHONE = '無効な携帯電話番号'

    exports.WARING_INVALID_QQ = '無効なqq番号'

    exports.WARING_DESCRIPTION_EMPTY = '説明情報は空ではありません。'

    exports.SUBMIT_HELP_TOO_FREQUENT = 'あまり頻繁に助けを求めないでください。'

    /**
     * =================================================
     * 音视频播放器相关话术
     * =================================================
     */

    exports.MEDIA_PLAYER_KEEP_ON = 'ビデオデバイスをオンにしてください。'

    exports.MEDIA_PLAYER_FILE_LOADING = '${fileName}を読み込んでいます'

    exports.MEDIA_PLAYER_CLOSE_VIDEO = 'カメラを開けました。クリックして相手の画像を閉じます。'

    exports.MEDIA_PLAYER_OPEN_VIDEO = 'カメラを開けました。クリックして相手の画像を開けます。'

    exports.MEIDA_PLAYER_CAMERA_OFF = '相手がカメラを開けていません。'

    exports.MEDIA_PLAYER_MIC_ON = 'マイクを開けました'

    exports.MEDIA_PLAYER_MIC_OFF = '未開封マイク'

    exports.MEDIA_PLAYER_CLOSE_MIC = 'をクリックして、相手のマイクをオフにします。'

    exports.MEDIA_PLAYER_POPUP = 'ポップアップウィンドウをクリックします'

    exports.MEDIA_PLAYER_SWITCH = 'クリックしてpptとビデオウィンドウを切り替えます。'

    exports.MEDIA_PLAYER_VIDEO_DOWNLINK_BANDWIDTH = '動画を受信:'

    exports.MEDIA_PLAYER_AUDIO_DOWNLINK_BANDWIDTH = 'オーディオを受信:'

    exports.MEDIA_PLAYER_VIDEO_UPLINK_BANDWIDTH = '動画リスト'

    exports.MEDIA_PLAYER_AUDIO_UPLINK_BANDWIDTH = 'アップロードオーディオ:'

    exports.MEDIA_PLAYER_FOLD = 'たたむ'

    exports.MEDIA_PLAYER_UNFOLD = '展開'

    /**
     * =================================================
     * CEF 相关话术
     * =================================================
     */

    exports.CEF_ERROR_PLAYBACK_AUDIO = 'オーディオデバイスにエラーが発生しました。'

    exports.CEF_ERROR_SYSTEM_NOT_SUPPORT
        = 'あなたのオペレーティングシステムはこの機能をサポートしていません。コンピュータを交換したり、オペレーティングシステムをアップグレードしたりしてください。'

    exports.CEF_ERROR_CAMERA_IS_BUSY
        = 'あなたのカメラは他のアプリケーションに使われるかもしれません。確認してください。'

    exports.CEF_ERROR_OPEN_MIC = 'マイクを開けませんでした。クライアントを再起動してください。'

    exports.ALERT_CREATE_STREAM_TIMEOUT = 'サウンドビデオストリームタイムアウトを取得。カメラデバイスを確認し、再試行をリフレッシュしてください。'

    exports.CEF_ERROR_WORK_MIC = 'マイクが正常に動作しません。確認してください。'

    exports.CEF_ERROR_OPEN_SPEAKER = 'スピーカーを開けませんでした。クライアントを再起動してください。'

    exports.CEF_ERROR_CAPTURE_AUDIO = 'マイクのデータ収集に失敗しました。クライアントを再起動してください。'

    /**
     * =================================================
     * 需要变量替换的一些话术
     * =================================================
     */

    exports.TPL_LOGIN_CONFLICT
        = 'アカウント/参加コードは${endType}でログインしています。確認して、もう一度ログインしてください。'

    exports.TPL_STUDENT_SEND_TEACHER_GIFT = '<em>${userName}</em>が先生にプレゼントを贈った'

    exports.TPL_TEACHER_RECEIVE_STUDENT_GIFT = '<em>${userName}</em>からギフトを受け取る'

    exports.TPL_TEACHER_FORBID_USER_SEND_MESSAGE = '<em>${userName}</em>は教師によって禁止されました'

    exports.TPL_CUSTOM_SERVICE_CALL
        = 'クリックして確認し、テクニカルサポートスタッフに電話してください<br/>携帯電話で電話に出てください<em> ${mobile} </em>'

    exports.TPL_DETECT_TOOL_NET_STATUS_SPEED = '<em> ${netStatusMsg} </em>、${speed} msの遅延'

    exports.TIME_NOCTICE_JOIN_CLASS = '${seconds}秒後に教室に再び入ります'

    /**
     * =================================================
     * 登录注册
     * =================================================
     */

    exports.LOGIN_REGISTER_LOGIN = 'ログイン'

    exports.LOGIN_REGISTER_REGISTER = '登録する'

    exports.LOGIN_REGISTER_LOGIN_WAITING = 'ログイン中..'

    exports.LOGIN_REGISTER_REGISTER_WAITING = '登録中…'

    exports.LOGIN_REGISTER_MOBILE = '携帯電話の番号を入力してください。'

    exports.LOGIN_REGISTER_SET_PASSWORD = 'パスワードを設定してください'

    exports.LOGIN_REGISTER_INPUT_PASSWORD = 'パスワードを入力してください'

    exports.LOGIN_REGISTER_INPUT_VERIFYCODE = '携帯の認証コードを入力してください。'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE = '認証コードを取得'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE_COUNTING = '秒後にやり直します'

    exports.LOGIN_REGISTER_MOBILE_ERROR = '正しい携帯電話番号を入力してください。'

    exports.LOGIN_REGISTER_PASSWORD_ERROR = '正しいパスワードを入力してください。'

    exports.LOGIN_REGISTER_CAPTCHA_ERROR = '正しいグラフィック認証コードを入力してください。'

    exports.LOGIN_REGISTER_VERIFYCODE_ERROR = '正しい検証コードを入力してください。'

    exports.LOGIN_REGISTER_DIALOG_TITLE = 'ログインを確認する'

    exports.LOGIN_REGISTER_LOGIN_BY_SMS = 'メールの登録'

    exports.LOGIN_REGISTER_LOGIN_BY_PASSWORD = 'パスワード登録'

    exports.LOGIN_REGISTER_INPUT_CAPTCHA = '下の文字を入力してください。'

    exports.LOGIN_REGISTER_SWITCH_ROLE = '学生の身分を持っていませんが、学生の身分を開通しますか？'

    /**
     * =================================================
     * 紧急呼叫（客服电话拨打）
     * =================================================
     */

    exports.CUSTOM_SERVICE_NEED_CALL = '問題がありますか？無料電話で助けを求めます。'

    exports.CUSTOM_SERVICE_CONFIRM_CALL = '呼び出しを確定する'

    exports.CUSTOM_SERVICE_REJECT_CALL = '携帯を持っていません'

    exports.CUSTOM_SERVICE_EXTRA_FEE
        = '（一部のユーザーは携帯電話のセットのせいで、事業者による受信やローミングの費用を徴収する可能性がある）'

    exports.CUSTOM_SERVICE_CALLING = '助けを求めて電話で呼び出し中です。'

    exports.CUSTOM_SERVICE_PICKUP = '接続してください<em>010-8548910</em>の着信<br />技術サポートを待っています。'

    exports.CUSTOM_SERVICE_DAIL = '救援電話をかける'

    exports.CUSTOM_SERVICE_DAIL_CONTENT
        = '技術サポート者に電話してもいいです。<br />技術サポートを待っています。<br /><em>40090910</em>'

    exports.CUSTOM_SERVICE_AUTO_CLOSE = 'ウィンドウが自動的に閉じられます。'

    exports.CUSTOM_SERVICE_DIALOG_TITLE = 'サービスを頼む'

    exports.CUSTOM_SERVICE_QQ_MESSAGE = '技術サポートを選択してqqを通じてリアルタイムで問題を解決します。'

    exports.CUSTOM_SERVICE_QQ_SYSTEM_INFO = 'システム：{system}バージョン番号：{system-version}'

    exports.CUSTOM_SERVICE_QQ_BROWSER_INFO = '端末：{browser}バージョン番号：{browser-version}'

    exports.CUSTOM_SERVICE_QQ_PRIMARY = 'テクニカルサポート'

    exports.CUSTOM_SERVICE_QQ_SECONDARY = 'テクニカルサポート2'

    /**
     * =================================================
     * 设备变更
     * =================================================
     */

    exports.DEVICE_CHANGE_ADD_AUDIO = '現在のマイクは新しいデバイスに切り替えられました。'

    exports.DEVICE_CHANGE_ADD_VIDEO = '現在のカメラは新たに挿入されたデバイスに切り替えられました。'

    exports.DEVICE_CHANGE_DEL_AUDIO = 'マイクデバイスの抜き出しは、デフォルトのデバイスに切り替えられました。'

    exports.DEVICE_CHANGE_DEL_VIDEO = 'カメラ機器の抜去は、デフォルトのデバイスに切り替えられました。'

    exports.DEVICE_CHANGE_RESET = 'クイック設定'

    /**
     * =================================================
     * 签到
     * =================================================
     */

    exports.SIGNIN_TITLE_HINT = '出席を取る'

    exports.SIGNIN_START = '出席を取る'

    exports.SIGNIN_STATUS = '状況に答える'

    exports.SIGNIN_TIME_NOTICE = '${seconds}以内に応答するように生徒を設定してください'

    exports.SIGNIN_ACK_COUNT = '${member}人が答えた'

    exports.SIGNIN_NACK_COUNT = '未回答の${member}人'

    exports.SIGNIN_EXPECT_COUNT = '${member}人にリーチする必要があります'

    exports.SIGNIN_LIST_DOWNLOAD = 'ダウンロード'

    exports.GROUP_SIGNIN_LIST_DOWNLOAD = 'このグループのリストをダウンロードします'

    exports.SIGNIN_NO_LIST = '人員名簿に回答していません。'

    exports.SINGIN_NO_NOTICE
        = 'システム展示でリストに答えられなかった50人は、完全なリストが必要なら、クリックしてください。'

    exports.SIGNIN_AGAIN = '再点呼'

    exports.SIGNIN_AGAIN_TIME_NOTICE = 'ロールコールは${seconds}秒で再開できます'

    exports.SINGIN_WAIT_TIME_NOTICE
        = '生徒は次々と答えています。結果は${seconds}秒で表示できます。しばらくお待ちください'

    exports.SIGNIN_REPLAY = '答えます'

    exports.SIGNIN_REPLAY_TIME_NOTICE = '先生はあなたに${seconds}秒以内にロールコールに応答するように頼みます'

    exports.SIGNIN_RESULT_GETTING = '点呼結果統計中'

    exports.SIGNIN_COMPLETE_NOTICE = '点呼統計が完了しました'

    exports.SIGNIN_GETTING_RESULT = '結果を表示'

    /**
     * =================================================
     * 到课名单
     * =================================================
     */

    exports.JOIN_USERLIST_TITLE_HINT = 'ヒント'

    exports.JOIN_USERLIST_TITLE_LIST = '出席リスト'

    exports.JOIN_USERLIST_HINT
        = '出席リストには、あなたの授業に応募した学生のニックネームを記録します。一番早い時間、最後に時間を残します。<br />名簿には、教室での時間が特に短い学生は含まれていません。<br />リストを生成する過程は、カートンを引き起こす可能性があります。<em>授業が終わったら、この機能を使うことをおすすめします。</em>。'

    exports.JOIN_USERLIST_COPY_HINT = 'レッスンリストが生成されました。csvファイルとしてエクスポートできます。'

    exports.LABEL_CONFIRM = '確認'

    exports.JOIN_USERLIST_CLOSE = '閉じる'

    exports.JOIN_USERLIST_FETCH = '生成リスト'

    exports.JOIN_USERLIST_FETCHING = '生成中..'

    exports.JOIN_USERLIST_STUDENT_ID = '学生アイドル'

    exports.JOIN_USERLIST_STUDENT_NAME = '学生のニックネーム'

    exports.JOIN_USERLIST_LOGIN_TIME = '最初の入場時間'

    exports.JOIN_USERLIST_LOGOUT_TIME = '最後の時間'

    exports.JOIN_USERLIST_GROUP = 'グループid'

    exports.JOIN_USERLIST_ENDTYPE = 'ターミナルタイプ'

    exports.JOIN_USERLIST_COPY = 'エクスポート'

    exports.JOIN_USERLIST_STILL_IN = 'まだ出発していません'

    exports.JOIN_USERLIST_NOBODY_HINT = 'まだ授業に来ていません。学生ですよ。'

    /**
     * =================================================
     * 助教链接
     * =================================================
     */

    exports.ASSISTANT_LINK = '助教リンク'

    exports.ASSISTANT_LINK_NEW_HINT
        = '[最新更新]助教は使えます。<em>クライアント</em>登録&録画&動画放送しましたよ！入り口：クライアント登録ページ右下角）'

    exports.ASSISTANT_LINK_HINT
        = '助教リンクをコピーして、小仲間に送ります。彼は助教になり、直接教室に入ります。<br />学生の発言を管理したり、学生の発言を禁止したり、授業の録音を手伝ったりする権限を持っています。'

    exports.ASSISTANT_LINK_LABEL_NAME = '助教名：'

    exports.ASSISTANT_LINK_LABEL_AVATAR = 'アイコンを選択:'

    exports.ASSISTANT_LINK_DEFAULT_NAME = '教えを助ける'

    exports.ASSISTANT_LINK_NAME_MAXLENGTH = '名前は8字以内です'

    exports.ASSISTANT_LINK_NAME_EMPTY = '助教の名前を入力してください。'

    exports.ASSISTANT_LINK_SUCCESS = '助教リンクの作成に成功しました。秘密に注意してください。'

    exports.ASSISTANT_LINK_COPY_SUCCESS = 'リンクのコピーに成功しました'

    exports.ASSISTANT_LINK_FAILURE = '補助教育のリンクが間違っています'

    /**
     * =================================================
     * 课件缩放工具条
     * =================================================
     */

    exports.DOC_QUALITY_LOW = '流暢：圧縮授業を使って、ページをめくるのが速いです。'

    exports.DOC_QUALITY_HIGH = 'テキストがはっきりしていますが、<em>簡単なカートン</em>。'

    exports.DOC_FIT_VIEW = '順応する'

    exports.DOC_FIT_WIDTH = '塗りつぶし'

    exports.ALLOW_STUDENT_CHANGE_PPT = '許可：学生のページをめくることができます。'

    exports.FORBID_STUDENT_CHANGE_PPT = '禁止：学生のページをめくることを禁止します。'

    exports.HIDDEN_REMARKINFO = '非表示：ppt内部メモテキストは表示されません。'

    exports.SHOW_REMARKINFO = '表示：ppt内部メモテキストを表示します。'

    /**
     * =================================================
     * 系统检测工具
     * =================================================
     */

    exports.DETECT_TOOL_DIALOG_TITLE = 'システム検出'

    exports.DETECT_TOOL_CUSTOM_SERVICE = '技術サポートを求める'

    exports.DETECT_TOOL_TIPS = '解決方法の提案：'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_GOOD = '優良-授業が流暢である'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_OK = '普通-たまにカートンがあります。'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_NORMAL = '劣る-常にカートンがあります。'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_BAD = '悪いです。授業ができません。'

    exports.DETECT_TOOL_NET_STATUS_GOOD = 'ネットワークが優れています'

    exports.DETECT_TOOL_NET_STATUS_OK = 'ネットワーク'

    exports.DETECT_TOOL_NET_STATUS_POOR = 'ネットワークが悪い'

    exports.DETECT_TOOL_NET_STATUS_TERRIBLE = 'ネットが悪いです'

    exports.DETECT_TOOL_NET_STATUS_DETECT = 'ネットワーク接続検出'

    exports.DETECT_TOOL_NET_STATUS_DETECTING = 'ネットワーク検出中…'

    exports.DETECT_TOOL_NET_STATUS_TIPS_HEADER = 'インターネットが良くない場合は、次のような方法を試してください。'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CLOSE_P2P
        = 'サンダーと他のp 2 pソフトをオフにして、ケーブルを使ってパソコンに接続します。'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CHECK_LAN = 'lan内に他のユーザーが大量の帯域幅を占めるかどうかを確認します。'

    exports.DETECT_TOOL_NET_STATUS_TIPS_REBOOT = 'コンピュータとルータを再起動します。'

    exports.DETECT_TOOL_NET_STATUS_NO_RESULT
        = '速度測定情報を取得していません。またはネットワークが切断されました。再測定してください。'

    exports.DETECT_TOOL_HELP_NET = 'インターネットによくある問題'

    exports.DETECT_REFRESH_NOTICE = '教室につながらない？ネットワークを切り替えて更新を試みることができます。'

    exports.DETECT_NET_PROGRAM_REFRESH_NOTICE = '再接続中です。少々お待ちください。'

    exports.DETECT_TOOL_REDETECT = '重さを測る'

    exports.DETECT_TOOL_SPEAKER_DETECT = 'スピーカー検出'

    exports.DETECT_TOOL_SPEAKER_INITIATING = 'スピーカー初期化中…'

    exports.DETECT_TOOL_SPEAKER_TEST_SOUND_PLAYING = '音楽の再生中をテストします。'

    exports.DETECT_TOOL_SPEAKER_HAVE_YOU_HEARD = 'テスト音が聞こえますか？'

    exports.DETECT_TOOL_SPEAKER_NO_DEVICE = 'スピーカーデバイスが検出されませんでした。'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHECK_PLUG = 'スピーカーの接続が正常かどうか確認してください。オープン状態です。'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_DEVICE = 'スピーカーデバイスを切り替え'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME = 'スピーカーの音量を調節する'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME_OUTER = '外付けスピーカーの音量を調節するボタン'

    exports.DETECT_TOOL_SPEAKER_TIPS_OS_SETTING
        = '開く<span class="os-setting-trigger">スピーカーの設定</span>を選択します。スピーカーが無効になっているか確認してください。'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_MAC
        = '開く<em>システムプリファレンス設定->サウンド->出力</em>を選択し、スピーカーの設定を確認します。'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_WINDOWS
        = '開く<em>スタート->コントロールパネル->サウンド->再生</em>を選択します。スピーカーが無効になっているか確認してください。'

    exports.DETECT_TOOL_HELP_SPEAKER = 'スピーカーによくある問題'

    exports.DETECT_TOOL_MIC_DETECT = 'マイク検出'

    exports.DETECT_TOOL_MIC_DETECTING = 'マイクに向かって話してください。'

    exports.DETECT_TOOL_MIC_DETECTING_TIPS
        = '話をする時はイヤホンをつけてスピーカーを閉じてから、エコーを避けるようにしてください。'

    exports.DETECT_TOOL_MIC_HAS_INPUT = '音声入力を検出しました。'

    exports.DETECT_TOOL_MIC_HAS_INPUT_WARNING
        = '強く提案します。外にスピーカーを置いてイヤホンをつけて、鳴きや返事を避けるようにします。'

    exports.DETECT_TOOL_MIC_NO_INPUT = 'サウンド入力が検出されませんでした。'

    exports.DETECT_TOOL_MIC_NO_DEVICE = 'マイクデバイスが検出されませんでした。'

    exports.DETECT_TOOL_MIC_TIPS_HEADER = '問題があれば、次のような方法を試してください。'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_VOLUME = 'マイクの音量を調節する'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_DEVICE = 'マイクデバイスを切り替え'

    exports.DETECT_TOOL_MIC_TIPS_HEADER_UNDETECTED = '次の方法を試してください。'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_PLUG = 'マイクの接続が正常かどうかを確認し、オープン状態です。'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_BLOCK
        = 'ブラウザとパソコンの執事ソフトが設備の使用をブロックしたかどうかを確認します。'

    exports.DETECT_TOOL_MIC_TIPS_OS_SETTING
        = '開く<span class="os-setting-trigger">マイクの設定</span>を選択します。マイクが無効になっているかどうか確認してください。'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_MAC
        = '開く<em>システムプリファレンス設定->サウンド->入力</em>を選択し、マイクの設定を確認します。'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_WINDOWS
        = '開く<em>スタート->コントロールパネル->サウンド->録音</em>を選択します。マイクが無効になっているかどうか確認してください。'

    exports.DETECT_TOOL_HELP_MIC = 'マイクによくある問題'

    exports.DETECT_TOOL_CAMERA_DETECT = 'カメラ検出'

    exports.DETECT_TOOL_CAMERA_HAS_CAMERA = '画像が見えますか？'

    exports.DETECT_TOOL_CAMERA_NO_CAMERA = 'カメラのデバイスが検出されませんでした。'

    exports.DETECT_TOOL_CAMERA_TIPS_HEADER = '画像が見えなかったら、次のような方法を試してください。'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_PLUG = 'カメラが正常に接続されているかを確認します。'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_CLOSE_OTHER
        = '他のカメラを占有する可能性のあるプログラムを閉じてみてください。'

    exports.DETECT_TOOL_CAMERA_TIPS_CHANGE_DEVICE = 'カメラの設備を切り替えます。'

    exports.DETECT_TOOL_CAMERA_TIPS_OS_SETTING = 'カメラの設定'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_MAC
        = 'はい、<em>アップル->本機について->プレビュー->システムレポート->カメラ/usb</em>でカメラの設備が正常にインストールされているかを確認します。'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_WINDOWS
        = 'はい、<em>スタート->コントロールパネル->デバイスマネージャ</em>でカメラの設備が正常にインストールされているかを確認します。'

    exports.DETECT_TOOL_HELP_CAMERA = 'カメラによくある問題'

    exports.DETECT_TOOL_FINISH = 'システム検出完了'

    exports.DETECT_TOOL_FINISH_TIPS
        = 'システムに問題がある場合は、クライアント、コンピュータ、ルータを再起動してみてください。または技術サポートに連絡して解決に協力してください。'

    /**
     * =================================================
     * settings
     * =================================================
     */

    exports.SETTINGS_MIC_PREFERENCE_SCALING = 'マイク強化'

    exports.SETTINGS_MIC_PREFERENCE_SCALING_UNIT = 'db'

    exports.SETTINGS_TIP_DETECT_CLOSE = '検出デバイスは${services}を閉じます。続行しますか？'

    exports.SETTINGS_INFO_TIP_OPEN_CAMERA = '動画が必要なら、カメラを開けてください。'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_CAMERA_FORBIDDEN = 'この授業は音声生放送です。カメラを使ってはいけません。'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_SCREEN_SHARE_FORBIDDEN
        = 'この授業は音声生放送で、スクリーン共有機能を使ってはいけません。'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_MEDIA_PLAY_FOBIDDEN
        = 'この授業はオーディオ生放送で、ビデオファイルを再生できません。'

    /**
     * =================================================
     * 媒体服务器切换后的相关提示
     * =================================================
     */

    exports.SWITCH_TIP_CLOSE_CAMERA = 'あなたのネットワークのボラティリティを検出しました。大きなロスがありました。'

    exports.SWITCH_TIP_SWITCH_CDN = 'あなたのネットワークのボラティリティが大きいということを検出しました。'

    exports.SWITCH_TIP_QUALITY
        = 'あなたのネットワークのボラティリティを検出しました。カバンの重大さを忘れました。鮮明度を下げて学生の端のカートンを緩和してください。'

    exports.SWITCH_TIP_NET_STATUS = 'あなたのネットワークのボラティリティが大きいということを検出しました。'

    exports.SWITCH_TIP_TEACHER_NET_STATUS = '先生の端末のネットの波動が大きくて、時々カートン現象があります。'

    /**
     * =================================================
     * 底部操作 class ation 相关
     * =================================================
     */
    exports.CLASS_ACTION_TIP_DOWNLOAD_WINDOWS
        = '手を挙げての発言はクライアントのみサポートされます。'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=windows" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD_MAC
        = '手を挙げての発言はクライアントのみサポートされます。'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=mac" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD
        = '手を挙げての発言はクライアントのみサポートされます。'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载'

    /**
     * =================================================
     * 进入教室过程中的提示
     * =================================================
     */

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECTING = 'メインサーバを接続中'

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECT_SUCCESS = 'メインサーバの接続に成功しました。'

    exports.ENTER_CLASSROOM_SERVER_INFO_FETCH_SUCCESS = 'サーバ情報の取得に成功しました。'

    exports.ENTER_CLASSROOM_ROOM_SERVER_CONNECT_SUCCESS = '教室サーバ接続に成功しました。'

    exports.ENTER_CLASSROOM_ROOM_SERVER_LOGIN_SUCCESS = '教室サーバ登録成功'

    exports.ENTER_CLASSROOM_AUTH_TOKEN_FAIL = '不正なユーザ'

    exports.ENTER_CLASSROOM_OVERMAN = 'この部屋は満室です。後でやり直してください。'

    exports.ROOM_SERVER_LOGIN_CONFLICT_CONFIRM
        = 'この教室にはすでに先生がいます。入るとその先生は教室を離れます。引き続き入りますか？'

    /**
     * =================================================
     * 新手引导相关话术
     * =================================================
     */

    exports.USER_GUIDE_DOWNLOAD_TEACHER
        = 'クライアントで音声を講義するビデオはもっと流暢で、教育機能がもっと豊富で、仲間たちは全部使っています。'
        + '你还等什么？快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    exports.USER_GUIDE_DOWNLOAD_STUDENT
        = 'クライアントで聴講するとビデオがもっと流暢になります。子供たちは全部使っています。まだ何を待っていますか？'
        + '快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    /**
     * =================================================
     * 服务器重连提示
     * =================================================
     */

    exports.RECONNECT_ROOM_SERVER_WAITING = 'ネットがダメです。ネットを確認してください。'

    exports.RECONNECT_ROOM_SERVER_SUB_WAITING = '再接続を試みています。'

    exports.ROOM_SERVER_LOGIN_EXPIRED_TIP = '教室はもう期限が切れています'

    /**
     * =================================================
     * 录制课程
     * =================================================
     */

    exports.RECORD_CLASS_REMIND = '録音が中断されました。録画をもう一度クリックしてください。'

    exports.RECORD_INFO_TIP = '録音授業を開始し、授業後に再生をアップロードすることを提案します。'

    exports.RECORD_COMPLETE_TIP
        = 'レッスンの録音が完了しました。<span class="btn-action">ローカルのレッスンファイルを開く</span>'

    exports.RECORD_STOPPING_TIP = 'ローカル録画ファイルを生成中です。しばらくお待ちください...'

    exports.RECORD_RESTART_TIP
        = 'ローカルの録音が停止しました。やり直してください。<span class="btn-action">開く</span>ローカルレコード'

    /**
     * =================================================
     * 自动录课
     * =================================================
     */

    exports.AUTO_RECORD_START = 'レッスンの録音は自動的に始まります。'

    exports.AUTO_RECORD_RESTART = 'レッスンの録音を再開します。'

    exports.AUTO_RECORD_STOP = 'レッスンの録音が中止されました。クライアント内で学生にアップロードして見てください。'

    exports.AUTO_RECORD_CLASS_COUNT_DOWN_TIP = '秒後に自動オン'
    exports.AUTO_RECORD_CANCEL = '録音をキャンセル'
    exports.AUTO_RECORD_LATER = '後で注意します'

    exports.AUTO_RECORD_MODE_CLOUD_AND_LOCAL = 'クラウド+ローカル'

    exports.AUTO_RECORD_MODE_CLOUD = '雲の端'

    exports.AUTO_RECORD_MODE_LOCAL = 'ローカル'

    exports.AUTO_RECORD_REASON = 'この授業は開講時に再生を提供するように設定します。'

    exports.AUTO_RECORD_TIP_NET_DISK_EMPTY
        = '資料の保存スペースがいっぱいです。クラウド録音ができません。拡張してから手動で録音を開けてください。'

    exports.NO_RECORD_WHEN_AUTO_RECORD
        = 'システムはクラウド録音がオンされていないことを検出しました。クラウド録音を開始しますか？'

    /**
     * =================================================
     * 环境监测
     * =================================================
     */

    exports.ENV_DETECT_HEADER = 'ネットワーク加速'

    exports.ENV_DETECT_ACTION = 'ワンタッチで加速'

    exports.ENV_DETECT_KILLING = '最適化中'

    exports.ENV_DETECT_KILL_COMPLETE = '最適化成功'

    exports.ENV_DETECT_PROCESS = 'オフを推奨するプログラム'

    /**
     * =================================================
     * CDN 厂商名称
     * =================================================
     */

    exports.CDN_DNION = '帝聯'

    exports.CDN_NET_CENTER = '網宿'

    exports.CDN_CHINA_CACHE = '青の増水'

    /**
     * =================================================
     * 录制
     * =================================================
     */

    exports.RECORD_COLLECTS_LOCAL_RECORD = 'ローカルレコード'

    exports.RECORD_COLLECTS_CLOUD_RECORD = 'クラウド録音'

    exports.RECORD_COLLECTS_ALL_RECORD = 'ローカル+クラウド録音'

    exports.RECORD_COLLECTS_CLOUD_RECORD_LIST = '管理クラウド再生'

    exports.RECORD_COLLECTS_PRE_START_INFO = '早くレッスンを始めて録画してください。'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME = 'レッスン終了時間が過ぎましたので、現地でのみ録画できます。'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_WEB = '授業終了時間が過ぎましたので、雲の上で録音してはいけません。'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_PAUSE
        = '授業終了時間が15分を超えました。クラウド録音が一時停止されたら自動的に終了しますか？'

    exports.RECORD_COLLECTS_CLOUD_RECORD_PAUSING_OVER_TIME
        = '授業が終わって15分以内に録音が再開されていません。クラウド録音は自動的に終了しますので、ご注意ください。'

    exports.CLOUD_RECORD_OVER_TIME_WARNING_INFO_BTN = '分かりました'

    exports.END_RECORD_COLLECTS_PAUSE_RECORD = '一時停止'

    exports.END_RECORD_COLLECTS_STOP_RECORD = '停止'

    exports.END_RECORD_THEN = 'しばらく生成しない'

    exports.END_RECORD_START_PLAYBACK = '生成を開始'

    exports.ALERT_STOP_PUSH_RECORD = 'スクリーンショットの録音を終了しますか？'

    /**
     * =================================================
     * 录课设置
     * =================================================
     */

    exports.RECORD_SETTINGS_TITLE = '授業の設定を記録します'

    exports.RECORD_SETTINGS_AUTO_START = '授業後に自動的に開く'

    exports.RECORD_SETTINGS_AUTO_START_LOCAL = 'ローカルレコード'

    exports.RECORD_SETTINGS_AUTO_START_CLOUD = 'クラウド録音'

    exports.RECORD_SETTINGS_RECORD_MODE = '録音モード'

    exports.RECORD_SETTINGS_RECORD_MODE_PART = 'ウィンドウの録音'

    exports.RECORD_SETTINGS_RECORD_MODE_FULLSCREEN = 'フルスクリーン録画'

    exports.RECORD_SETTINGS_PATH = 'ビデオを保存します。'

    // exports.RECORD_SETTINGS_REMEMBER = '记住选择（可到“更多 - 录课设置”中修改）';

    exports.RECORD_SETTINGS_LOCATION_TIP = '「詳細-レッスン設定」で変更できます。'

    /**
     * =================================================
     * 云端录制
     * =================================================
     */

    exports.CLOUD_RECORD_CONFIRM_START
        = 'クラウド録音を開始し、授業後に自動的にコースを生成して再生しますか？<br />（現在は授業中のクラウド録音はサポートされていません）'

    exports.CLOUD_RECORD_START_TIP_SDK
        = 'クラウドは直接クラウドサーバで録音して、現地では記録授業を保存しません。<br />'
        + 'ファイルは、コース終了後10分で自動的にコース再生を行います。<br />'

    exports.PUSH_RECORD_START_TIP_SDK
        = 'スクリーンショットのストリーミング録画は、クライアントがオンしてフルスクリーンの状態を維持する必要があります。<br />'
        + '録画ファイルはローカルに保存されていません。授業終了後10分で自動的にコース再生を行います。<br />'
        + '注意事項：<br />'
        + '    1、録音端のスピーカーを閉じないでください。でないと、音が録音できません。<br />'
        + '    2、クライアントを録画ウィンドウの外に移動しないでください。そうでないと、移動した部分はブラックスクリーンを表示します。'

    exports.ALERT_PUSH_RECORD_NETWORK_ERROR
        = 'ネットワークが切断されている可能性がありますので、ネットワークを確認してやり直してください。'

    exports.CLOUD_RECORD_OVERTIME_STOP_TIP = '授業終了時間を8時間超過しました。クラウド録音は自動的に停止します。'

    exports.CLOUD_RECORD_PRE_START_TIP = 'クラウド録音をオンにして、授業後に自動的に再生を生成します。'

    exports.CLOUD_RECORD_OVERTIME_TIP = '授業終了時間が過ぎましたので、クラウドを開けて授業を記録してはいけません。'

    exports.CLOUD_RECORD_RESTART_TIP
        = '授業中に録画を一時停止したい場合は、停止をクリックして録画を再開する必要があります。'

    exports.CLOUD_RECORD_WITHOUT_TEACHER_WARNING = '先生は生放送中ではなく、雲を開けての録画は禁止されています。'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGININ_SUCCESS = '答えが当たる'

    /**
     * =================================================
     * 磁盘空间
     * =================================================
     */

    exports.NET_DISK_INFO_TITLE = 'ヒント'

    exports.NET_DISK_INFO_BTN = '分かりました'

    exports.NET_DISK_INFO_POOR_PREFFIX = '雲の保存空間は残りわずかです。'

    exports.NET_DISK_INFO_POOR_SUFFIX
        = 'mb、スペースがいっぱいになったら、授業内容をアップロードできません。<a target="_blank" href="/teacher_center/storage_space">買います</a>より多くの雲の記憶空間または<a target="_blank" href="/teacher_center/netdisk">整理する</a>不要ファイル'

    exports.NET_DISK_INFO_POOR_WRITE_PREFFIX = '雲の保存空間は残りわずかです。'

    exports.NET_DISK_INFO_POOR_WRITE_SUFFIX = 'mbはクラウドで録音できなくなります。'

    exports.NET_DISK_INFO_EMPTY
        = '雲の保存スペースが足りないので、授業をアップロードできません。すぐにお願いします。<a target="_blank" href="/teacher_center/storage_space">買います</a>より多くの雲の記憶空間または<a target="_blank" href="/teacher_center/netdisk">整理する</a>不要ファイル'

    exports.NET_DISK_INFO_EMPTY_WRITE_PREFFIX = '雲の保存スペースが超過されました。'

    exports.NET_DISK_INFO_EMPTY_WRITE_SUFFIX = 'mbはクラウドで録音できなくなります。'

    exports.NET_DISK_INFO_EXCEED_WRITE_PREFFIX = '雲の保存スペースが超過されました。'

    exports.NET_DISK_INFO_EXCEED_WRITE_SUFFIX = 'mbはもうクラウドで録音できません。'

    /**
     * =================================================
     * 用户列表更多选项按钮
     * =================================================
     */

    exports.MORE_SETTINGS_BUTTON_FORBID_SEND_MESSAGE = 'チャット禁止'

    exports.MORE_SETTINGS_BUTTON_UNFORBID_SEND_MESSAGE = 'チャットを許可する'

    /**
     * =================================================
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'サードパーティプッシュフローサービス'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'rtmpストリームアドレス:'
    exports.LABLE_SERVER_STATUS_NORMAL = 'プッシュフローサービスは正常です'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'オーディオデータを転送'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'プッシュフローサービス異常'
    exports.LABLE_SERVER_STATUS_PREPARING = 'サーバー準備中…'

    exports.BUTTON_REFRESH_LIST = 'リストを更新'
    exports.BUTTON_COPY_URI_OF_SERVER = 'コピー'
    exports.BUTTON_RESTART_SERVER = 'サービスを再起動する'
    exports.BUTTON_START_TRANPONDING_STREAM = '転送を開始'
    exports.BUTTON_STOP_TRANPONDING_STREAM = '転送を停止'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'ストリーム名'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'ビデオコード'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = '動画の解像度'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = '音声コード'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = '音声サンプル'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = '状態'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'データなし'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = '転送中'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'サポートしない'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = '転送なし'

    exports.RESTART_SERVER_FAILED_TIP = 'サービスの再起動に失敗しました'
    exports.COPY_SUCCESS_TIP = 'コピー成功'
    exports.PUSH_STREAM_FAILED_TIP = 'ストリームの転送に失敗しました'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'サーバのアドレスを取得できませんでした。'

    exports.STREAM_INFO_MARK_IS_TRANSPONDING = '回転'

    exports.INFO_NO_DATA_FROM_STREAM
        = '第三者ストリームにデータがない場合は、設備とネットワークを確認したり、サービスを再開してください。'

    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'ホワイトボード/レッスン'
    exports.ASSIST_CAMERA = 'サブカメラ'
    exports.SCREEN_SHARE = 'スクリーン共有'

    exports.CLOSE_MEDIA_BEFORE_DETECT = 'まずビデオファイルの再生を停止してください。'
    exports.CLOSE_DESKTOP_SHARE_BEFORE_DETECT = '先にスクリーンを閉じて共有してください。'

    exports.SETTING_CAMERA_DISABLE = 'カメラ使用中に設定を変更できません。'
    exports.SETTING_ASSIST_CAMERA_DISABLE = 'サブカメラ使用中に設定を変更できません。'
    exports.SETTING_SHARE_DISABLE = 'デスクトップ共有使用中に設定を変更できません。'

    /**
     * =================================================
     * 邀请发言
     * =================================================
     */
    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INIT = '麦を招く'

    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INVITING = '招待をキャンセルする'

    exports.MORE_SETTINGS_MARK_INVITING = '招待中'

    exports.MORE_SETTINGS_MARK_SPEAKING = '発言中'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_INIT = '強制アップ'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_OPENING = '開いています'

    exports.MORE_SETTINGS_BUTTON_SPEAK_INVITE_UNSUPPORTED_HOVER_TIP
        = 'このユーザーはウェブページ版を使っていますが、ライ麦の招待はサポートされていません。'

    exports.BUTTON_OPEN_WEBCAM = ' カメラを開ける '

    /**
     * =================================================
     *
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'サードパーティプッシュフローサービス'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'rtmpストリームアドレス:'
    exports.LABLE_SERVER_STATUS_NORMAL = 'プッシュフローサービスは正常です'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'オーディオデータを転送'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'プッシュフローサービス異常'

    exports.BUTTON_COPY_URI_OF_SERVER = 'コピー'
    exports.BUTTON_RESTART_SERVER = 'サービスを再起動する'
    exports.BUTTON_START_TRANPONDING_STREAM = '転送を開始'
    exports.BUTTON_STOP_TRANPONDING_STREAM = '転送を停止'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'ストリーム名'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'ビデオコード'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = '動画の解像度'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = '音声コード'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = '音声サンプル'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = '状態'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'データなし'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = '転送中'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'サポートしない'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = '転送なし'

    exports.RESTART_SERVER_FAILED_TIP = 'サービスの再起動に失敗しました'
    exports.COPY_SUCCESS_TIP = 'コピー成功'
    exports.PUSH_STREAM_FAILED_TIP = 'ストリームの転送に失敗しました'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'サーバのアドレスを取得できませんでした。'
    exports.STREAM_INFO_MARK_IS_TRANSPONDING = '回転'
    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'ホワイトボード/レッスン'
    exports.ASSIST_CAMERA = 'サブカメラ'
    exports.SCREEN_SHARE = 'スクリーン共有'

    exports.SIGNIN_FORBID = '前回のカウントダウンが完了した1分後に次の出席ができます。'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGNIN_FORBID = '前回のカウントダウンが完了した1分後に次の出席ができます。'

    exports.BEGIN_EXAM_TIP = 'オープンを確認して随堂試験を行いますか？'

    exports.END_EXAM_TIP = '閉館を確認して同庁で試験しますか？'

    exports.BEGIN_EXAM_INFO = '試験はもう始まった'

    exports.END_EXAM_INFO = '試験の中途で閉館した'

    exports.UNKNOW_EMOTION = '【サポートされていない表情】'

    /**
     * =================================================
     * 升级浏览器提示
     * =================================================
     */
    exports.UPGRADE_CLOSE_POWER_SAVING_MODE = '省電力モードをオフにする'

    exports.UPGRADE_NOTICE_SAFARI
        = 'safariブラウザを使用していますので、省電力モードをオフにして、ビデオを有効にして正常に授業を受けられるようにしてください。'

    exports.UPGRADE_SAFARI_SETTING = 'safari設定-高級'

    exports.UPGRADE_CANCEL_CHECK = 'チェックを解除'

    exports.UPGRADE_NOTICE_NO_FLASH
        = 'システムがあなたのflash部品を検出して正常に動作できなくなり、教室の機能が正常に使えなくなります。<br />下の動画を再生してみてください。再生できないなら、ダウンロードして使ってください。'

    exports.UPGRADE_BROWSER_GOOGLE = 'googleブラウザ'

    exports.UPGRADE_FAIL_CONTACT_TEL = '問題が解決できない場合は、カスタマーサービス400-910-910に連絡してください。'

    exports.UPGRADE_CLOSE_POWER_SAVING_MODE_CHROME
        = '最新バージョンのchromeブラウザを使用していますので、省電力モードをオフにして、ビデオを有効にして正常に授業を受けられるようにしてください。'

    exports.UPGRADE_CHROME_SETTING_STEP_ONE = 'chromeプラグイン設定ページに入ります。'

    exports.UPGRADE_CHROME_SETTING_STEP_TWO = '常にadobe flash playerを実行できるようにチェックします。'

    exports.UPGRADE_REFRESH_LIVE_ROOM = '教室のページを更新します'

    exports.UPGRADE_NO_FLASH_CAN_NOT_START
        = 'あなたのブラウザにflashプラグインがインストールされていないと、正常に授業ができません。'

    exports.UPGRADE_INSTALL_GUIDE = 'インストールガイド'

    exports.UPGRADE_TAKE_A_LOOK = 'まず目を通す'

    exports.UPGRADE_NOTICE_TO_LOW_BROWSER
        = 'あなたのブラウザはオンライン教室の強力な機能を体験しにくいです。高級ブラウザに交換することをお勧めします。'

    exports.UPGRADE_ENABLE_NEW_TECH = 'すぐに最新の科学技術を有効にします。'

    exports.UPGRADE_BY_REJECT = '間に合わせましょう'

    exports.FLASH_CAN_NOT_USE = 'flashプラグインのロードに失敗しました。以下の操作を試してみてください。'

    exports.CLICK_ALLOW_TIP = 'ヒントで「許可」を選択します。'

    exports.CLICK_INSTALL_TIP = 'を選択して、'

    exports.CLICK_TIP = 'クリック'

    exports.ALLOW_FLASH = 'flashを有効にする'

    exports.DOWNLOAD_FLASH = 'flashをダウンロード'

    /**
     * =================================================
     * 管理课件
     * =================================================
     */

    exports.DOCUMENT_UPLOAD = '授業のアップロード'

    exports.DOCUMENT_UPLOAD_ING = 'アップロード中'

    exports.DOCUMENT_UPLOAD_FROM_NETDISK = 'データベースから追加'

    exports.DOCUMENT_HAS_ADD = '授業を追加しました'

    exports.DOCUMENT_SUPPORT_FORMAT = 'ppt、pptx、doc、docx、jpg、png、pdfに対応しています。'

    exports.DOCUMENT_MOVE_UP = '上へ移動'

    exports.DOCUMENT_MOVE_DOWN = '下に移動'

    exports.DOCUMENT_UPLOAD_STAUS_CACEL = 'アップロードをキャンセル'

    exports.DOCUMENT_UPLOAD_STAUS_ING = 'アップロード中'

    exports.DOCUMENT_UPLOAD_STAUS_FAIL = 'アップロードに失敗しました'

    exports.DOCUMENT_TRANSFORM_STATUS_FAIL = 'トランスコード失敗'

    exports.DOCUMENT_TRANSFORM_STATUS_WAIT = 'トランスコードを待つ'

    exports.DOCUMENT_TRANSFORM_ING = 'トランスコード中'

    exports.DOCUMENT_HAS_ADD_STATUS = '追加しました'

    exports.DOCUMENT_TRANSFORM_NOTICE = 'wps編集した文書はpdfに変換してアップロードしてください。'

    exports.DOCUMENT_DEMO_LINK = 'この点をクリックして変換教程を表示します。'

    exports.DOCUMENT_CAN_USE_STATUS = '使用可能'

    exports.DOCUMENT_HAS_BE_CHECKED = '選択済み'

    exports.DOCUMENT_UPLOAD_ING_NOTICE = 'ファイルはアップロード中です。少々お待ちください。'

    exports.DOCUMENT_MANAGEMENT = 'ファイル管理'

    exports.DOCUMENT_BACK_TO_MANAGEMENT = 'レッスン管理に戻る'

    exports.SURVEY_PLEASE_INPUT_ANSWER = '答えを入力してください'

    exports.PLACEHOLDER_NOITCE_CONTENT = '公告の本文を入力してください。'

    exports.PLACEHOLDER_NOITCE_LINK = 'お知らせジャンプリンク（オプション）を入力してください。'

    exports.PLACEHOLDER_NOITCE_GROUP_CONTENT = 'お知らせ本文を入力してください。'

    exports.PLACEHOLDER_NOITCE_GROUP_LINK = 'お知らせジャンプリンク（オプション）を入力してください。'

    exports.NOTICE_LINK_ERROR_HINT = 'リンク形式が正しくありません。'

    exports.KICK_OUT = '教室を蹴る'

    exports.ENTER_CLASSROOM_KICKED_OUT = '教室を出てはいけません。'

    exports.KICKED_OUT_TIP = '教室から出てくださいました。'

    exports.KICKED_OUT_BY_AUDITION_END_TIP
        = 'あなたの試聴時間はもう来ました。もし授業を続けたいなら、申し込んでから参加してください。'

    exports.KICKED_OUT_BY_ROOM_DISABLED_TIP = '現在の生放送は無効です。生放送室に出てください。'

    exports.ALERT_KICK_OUT_AFTER_CLASS_30_MINUTES = 'レッスンは終了しましたので、次回もご覧ください。'

    exports.CLASS_END_TIP = '先生はもう授業が終わりました。'

    exports.CLASS_ENDED = '授業はもう終わりました'

    exports.TIME_BEFORE_CLASS_END = 'クラスから出るまでにまだ${time}秒あります'

    exports.CLASS_HAS_BEGAN_TIME = 'クラス開始 ${hours} 時間 ${minutes} 分 ${seconds} 秒'

    exports.WARNING_APPLY_SPEAK_STATUS_SWITCH_FREQUENT = '頻繁に発言状態を切り替えないでください。'

    /**
     * =================================================
     * 设置主讲人
     * =================================================
     */

    exports.YOU_ARE_PRESENTER = '主講の先生に設定されています。'

    exports.YOU_ARE_NOT_PRESENTER = '主講先生の権限を取り消されました。'

    exports.SET_USER_PRESENTER_TIP = 'プレゼンターは${username}に切り替えました'

    exports.CANCEL_USER_PRESENTER_TIP = 'ユーザー${username}の講師の許可が取り消されました'

    exports.CANCEL_USER_PRESENTER_WHEN_OUT_TIP = 'ユーザー${username}が教室を出て、講師の許可が取り消されました'

    exports.OPEN_CAMERA_FAIL_TIP = 'カメラを開けませんでした。'

    exports.OPEN_MIC_FAIL_TIP = 'マイクを開けませんでした。'

    exports.PRESENTER_IN = '先生は教室に入りました。'

    exports.PRESENTER_OUT = '先生は教室を離れました。'

    exports.BJY_SUPPORT = '百軒の雲は生放送サービスを提供しています。'

    exports.CONFIRM_SEND_PRIZE = 'お年玉を送りますか？'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_CPU
        = 'コンピュータcpuの使用率が高すぎることを検出しました。正常な生放送を保証するために、生放送とは関係のないソフトウェアをオフにしてください。'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_MEMORY
        = 'コンピュータのメモリの使用率が高すぎることを検出して、正常に生放送することを保証するため、生放送と関係がないソフトウェアを閉鎖して下さい。'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_BOTH
        = 'コンピュータcpuとメモリの使用率が高すぎることを検出しました。正常な生放送を保証するために、生放送とは関係のないソフトウェアをオフにしてください。'

    exports.NETWORK_BAD_WARNING = 'ネットの状況が悪くて、音声動画がカートンを発生する可能性があります。'

    exports.CHANGE_LINK_TYPE_DUE_TO_NETWORK = 'ネットワークの状況が悪いので、他のリンクに切り替えてみます。'

    exports.LABEL_WHITEBOARD_FILL = '塗りつぶし'

    exports.LABEL_WHITEBOARD_STROKE = 'へりを引く'

    exports.LABEL_FORBID_RAISE_HAND = '挙手禁止'

    exports.INFO_FORBID_RAISE_HAND = '挙手は禁止されています'

    exports.INFO_UNFORBID_RAISE_HAND = '挙手を許可しました'

    exports.INFO_FORBID_OPEN_MIC = 'マイクのオンは禁止されています。'

    exports.INFO_UNFORBID_OPEN_MIC = 'マイクのオープンを許可しました。'

    exports.INFO_TEACHER_FORBID_RAISE_HAND = '挙手は禁止されています'

    exports.LABEL_GUEST = 'ユーザー'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_NEW
        = '前回のクラウド録音を続けますか？それとも新しいクラウド録音を開始しますか？'

    exports.INFO_BUTTON_CONTINUE = '引き続き録画します'

    exports.INFO_BUTTON_START_NEW = '新しい録音'

    exports.LABEL_GUEST = 'ユーザー'

    exports.SELECT_PROGRAM = '共有するプログラムを選択してください。'

    exports.CONFIRM_REMOVE_DOCUMENT_TRANSFORM_ING = 'ドキュメントはトランスコード中です。本当に削除しますか？'

    exports.BUTTON_UPLOAD_PPT_DOCUMENT = 'アクティブppt'

    exports.BUTTON_CHROME_FLASH_USER_GUIDE1_COMPLETE = '設定完了'

    exports.PRE_STEP = '前へ'

    exports.NEXT_STEP = '次のステップ'

    exports.TIP_CHROME_FLASH_MORE_SETTING = '以上の方法はまだ問題を解決していませんか？'

    exports.VIEW_MORE_SETTING = '詳細設定を表示'

    exports.LABEL_NO_LONGER_REMIND = 'もうヒントを与えません'

    exports.BUTTON_CLOSE = '閉じる'

    exports.CHROME_UPGRADE_INSTRUCTION
        = 'ブラウザの中のflash playerに異常があります。以下の方法で正しく設定してから生放送してください。'

    exports.CHROME_TIP_FLASH_SETTING_SET = '1.下図の青い枠の表示エリアを'

    exports.CHROME_TIP_FLASH_SETTING_ALLOW = 'このサイトでは常に許可されています。'

    exports.CHROME_TIP_FLASH_SETTING_THEN = 'を選択し、'

    exports.CHROME_TIP_FLASH_SETTING_REFRESH = '更新'

    exports.CHROME_TIP_FLASH_SETTING_BROWSER = 'ブラウザ'

    exports.CHROME_TIP_FLASH_DOWNLOAD
        = '2.設定後もこのページが表示されると、最新のflash playerをダウンロードしてインストールする必要があります。'

    exports.DOWNLOAD_FLASH = 'すぐにダウンロード'

    exports.CHROME_MORE_SETTING_FLASH = '詳細設定を表示'

    /**
     * apple 帮助信息
     */
    exports.APPLE_HELP_INFO = '8610-85255961に電話したり、yandongにメールしたりします。liu@apple.com'

    exports.TIP_DO_NOT_SUPPORT_LOW_VERSION_IE
        = 'はい、ブラウザのバージョンが低すぎます。ie 9以下のバージョンはもうサポートされていません。'

    exports.TIP_LOW_VERSION_IE_UPDATE_BROWSER = '1、ブラウザをアップグレードしてください。'

    exports.TIP_LOW_VERSION_IE_DOWNLOAD_CHROME = 'すぐにダウンロード'

    exports.TIP_LOW_VERSION_IE_CHANGE_MODE
        = '2、360、qq、捜狗などのブラウザを使うなら、極速モードに切り替えてください。'

    exports.TIP_LOW_VERSION_IE_CHANGE_BROWSER = '3、他のブラウザを交換する'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_LIVE = '中継'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_CLASSROOM = 'クラウド教室'

    exports.TIP_INVITATION_NAME_INPUT = 'ニックネームを入力してください:'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE = '携帯番号を入力してください。'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE_WRONG = '正しい携帯番号を入力してください。'

    exports.PLACEHOLDER_INVITATION_JOINCODE_INPUT = '生放送管理者に参加コードを要請してもいいです。'

    exports.TIP_INVITATION_GET_JOINCODE = '参加コードを入力してください:'

    exports.TIP_INVITATION_NAME_SHOULD_NOT_BE_EMPTY = 'ニックネームは空ではありません'

    exports.TIP_INVITATION_MOBILE_SHOULD_NOT_BE_EMPTY = '携帯の番号は空いてはいけません。'

    exports.TIP_INVITATION_JOINCODE_SHOULD_NOT_BE_EMPTY = '参加コードは空です。'

    exports.TIP_INVITATION_JOINCODE_IS_NOT_RIGHT = '正しい参加コードを入力してください。'

    exports.LOCAL_RECORD_PATH_NULL = 'ビデオをローカルに保存するパスを選択してください。'

    exports.INFO_LOCK_SCREEN = '学生の鍵を開けました'

    exports.INFO_UNLOCK_SCREEN = 'ロック解除済み'

    exports.INFO_LOCK_SCREEN_STUDENT = '先生はもう学生のロックを開けました。今は他のソフトを操作できません。'

    exports.LABEL_NERVER_PRINT = 'もうヒントを与えません'

    exports.LABEL_LOCK_SCREEN_OPEN = '開く'

    exports.INFO_LOCK_SCREEN_FIRST
        = '学生ロックをオンにすると、windowsクライアントを使用している学生は本生放送ソフトしか使えません。'

    exports.INFO_COLLECT_SYSTEM_SOUND_FIRST
        = 'オーディオの音が聞こえないようにしてください。採集システムの音をオンにすると、スピーカーの音を下げたり、スピーカーの音を静かにしたりできます。'

    exports.MEDIA_PLAYER_LOAD_FILE_FAILED
        = 'ファイルの読み込みに失敗しました。このファイルがメディアファイルか他のファイルかを確認してください。'

    exports.CLASS_SWITCH_PARENT_TIP = '小隊に入る'

    exports.CLASS_SWITCH_CHILD_TIP = '大役につく'

    exports.PARENT_CLASS_SWITCH_PARENT_TIP = 'グループに分けて討論する'

    exports.PARENT_CLASS_SWITCH_CHILD_TIP = '大便で集合する'

    exports.CLASS_SWITCH_PARENT_SUCCESS_TIP = 'すでに大班の授業に入った'

    exports.CLASS_SWITCH_CHILD_SUCCESS_TIP = '班切りになった'

    exports.CLASS_SWITCH_ROOM_SERVER_WAITING = '部屋を切り替えて、再接続中です。'

    exports.CLASS_SWITCH_TIP = '教室を切り替えますか？'

    exports.CLASS_SWITCH_TIP_CLOUD_RECORD
        = '<div class="confirm-class-switch-tip">大きなクラスに入ると、雲の上の録音は一時停止されます。小隊に戻って再生を生成します。</div>'

    exports.CLASS_SWITCH_MEDIA_PLAYER_TIP = 'まず地元の動画の再生を中止してください。'

    exports.CLASS_SWITCH_THIRD_PUSH_TIP = 'まず第三者のプッシュフローを停止してください。'

    exports.CLASS_SWITCH_SCREEN_SHAR_TIP = '先にデスクトップ共有を停止してください。'

    exports.CLASS_SWITCH_VIDEO_LAYOUT_TIP = 'まずビデオレイアウトを変更してください。'

    exports.CLASS_SWITCH_EXAM_TIP = 'まずコーステストを中止してください。'

    exports.CLASSROOM_ENTER_COUNT_DOWN_LABEL = 'カウントダウン:'

    /**
     * 图片添加至文档
     */
    exports.LABEL_IMAGE = '画像'

    exports.LABEL_IMAGE_VIEW = '画像のプレビュー'

    exports.LABEL_IMAGE_DOWNLOAD = '画像をダウンロード'

    exports.LABEL_ADD_TO_DOCUMENT = 'レッスンに追加'

    exports.LABEL_OPEN_ON_BLACKBOARD = '追加して開く'

    exports.INFO_IMAGE_ADD_SUCCESS = '画像を文書領域に追加しました。'

    exports.INFO_IMAGE_ADD_FAIL = '画像を文書に追加できませんでした。'

    exports.WARING_IMAGE_HAS_ADDED = '画像をドキュメントに追加しました。重複しないでください。'

    exports.QRCODE_IMAGE_UPLOAD_DONE = 'アップロードは成功し、${countDown}秒で終了します...'

    /**
     * 问答提示
     */
    exports.INFO_QUESTION_ANSWERED = '先生はあなたの質問に答えました。早く調べに行きましょう。'

    exports.CONFIRM_CLOSE_QUSETION_ANSWER = 'まだ未送信の内容がありますが、クローズを確認しますか？'

    /**
     * 浏览器不兼容提示
     */
    exports.BROWSER_NOT_SUPPORT_TIP_IE
        = 'ブラウザのバージョンが低すぎます。ie 10または以上のバージョンにアップグレードしてください。'

    exports.BROWSER_NOT_SUPPORT_TIP_WECHAT
        = 'wechatにブラウザが内蔵されていませんので、他のブラウザに転送して開けてください。'

    exports.BROWSER_NOT_SUPPORT_TIP_WEBRTC
        = 'あなたのブラウザはwebrtcタイプのコースをサポートしていません。最新バージョンのchromeブラウザを使ってください。'

    /**
     * 抽奖
     */

    exports.LOTTERY_STATUS_ING = '抽選中、残り'

    exports.LOTTERY_COMMADN_ING_TIP = '現在もパスワード抽選が行われていますが、事前に当選者の発表が行われていますか？'

    exports.LOTTERY_BUTTON_CONTINUE = '引き続き抽選します'

    exports.LOTTERY_BUTTON_BEGIN_NOW = '今から賞をいただきます'

    exports.LOTTERY_BEGIN_IN_CHAT = 'チャットエリアでパスワードを入力して抽選に参加します。'

    exports.LOTTERY_MESSAGE_TIP_BEFORE = '入力'

    exports.LOTTERY_MESSAGE_TIP_AFTER = '抽選に参加する'

    /**
     * 音频设备统一切换
     */
    exports.COMBINED_AUDIO_DEVICE_SWITCH_CONFIRM = '同じデバイスのマイク/スピーカーが有効になっていますか？'

    exports.COMBINED_AUDIO_DEVICE_SWITCH_OK = '有効にする'

    /*
     * 授权画笔
     */
    exports.PAINT_AUTHORIZE_TIP_ENABLE = '先生はあなたに画筆を使うように授権しました。'

    exports.PAINT_AUTHORIZE_TIP_DISABLE = '先生はもうあなたのペンの権限を回収しました。'

    /*
     * 切换布局
     */
    exports.SWITCH_LAYOUT_METTING = 'ギャラリーレイアウトに切り替えました。'

    exports.SWITCH_LAYOUT_MONKEY = '三分割スクリーンレイアウトに切り替えました。'

    exports.CHECK_GRAYSCALE_FAIL = '環境の切り替えに失敗しました。百軒のクラウド技術に連絡して問題を解決してください。'

    exports.SWITCH_LAYOUT_SINGLE = '単一ビデオレイアウトに切り替えました。'

    exports.DEVICE_IS_USING = 'デバイスが使用中です。'

    exports.LINK_SHARE_SUCCESS = 'リンクをクリップボードにコピーしました。'

    exports.SHARE_LABEL_TITLE = 'スクリーン共有'

    exports.TEXT_NOTICE_LABEL_TITLE = '文字の公告'

    exports.IMG_NOTICE_LABEL_TITLE = '写真のお知らせ'

    exports.USER_TAB_ALL = '全メンバー'

    exports.USER_TAB_FORBID = 'ユーザーを禁止する'

    exports.USER_TAB_KICKOUT = 'ユーザを蹴られる'

    exports.RECORD_COMPLETE_LIVE_TIP = 'レッスンの録音が完了しました'

    exports.OPEN_RECORD_FILE = 'ローカルのレッスンファイルを開く'

    exports.HTTP_REQUEST_ERROR = 'ネットワーク要求が失敗しました。ネットワークを確認してください。'

    /*
     * 权限控制
     */
    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_ENABLE = '先生は文書のコントロール権限を付与しました。'

    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_DISABLE = '先生はあなたの文書のコントロール権限を回収しました。'

    exports.AUTH_MANAGEMENT_LABEL_TITLE = '権限管理'

    exports.TEXT_NO_SPEAK_AUTH = 'あなたは今麦に乗る権限がありません。'

    exports.TEXT_SPEAK_AUTH_NO = '先生は上の麦の権限を回収しました。'

    exports.TEXT_NO_NOTICE_AUTH = 'あなたは現在公告権限を持っていません。'

    exports.TEXT_NOTICE_AUTH_NO = '先生はもうあなたの公告権限を回収しました。'

    exports.TEXT_NO_DOCUMENT_UPLOAD_AUTH = '現在は文書のアップロード権限がありません。'

    exports.TEXT_DOCUMENT_UPLOAD_AUTH_NO = '先生はあなたの文書のアップロード権限を回収しました。'

    exports.TEXT_NO_PAINTER_AUTH = '今はペンを描く権限がありません。'

    exports.TEXT_PAINTER_AUTH_NO = '先生はもうあなたのペンの権限を回収しました。'

    exports.TEXT_NO_CLASS_START_END_AUTH = 'あなたは今授業を受ける権限がありません。'

    exports.TEXT_NO_CLOUD_RECORD_AUTH = 'あなたは現在クラウド録音の権限がありません。'

    exports.NO_RECORD_AUTH = 'クラウド録音機能を使うには、まずクラウドリクエストラインを開通してください。'

    exports.TEXT_NO_FORBID_AND_KICK_AUTH = 'あなたには禁言と蹴り権限がありません。'

    exports.TEXT_NO_QUIZ_AUTH = 'あなたは現在アンケートを発表する権限がありません。'

    exports.CONFIRM_RELOAD = '教室にまた入ることを確認しますか？'

    exports.CONFIRM_CLOSE_ROOM
        = '教室を中止しますか？</br>放送終了後、すべてのユーザーが教室を蹴られます。教室は閉鎖されます。また入ることができません。'

    exports.EXTENSION_LABEL_TITLE = 'スクリーン共有プラグインインストールウィザード'

    exports.FORBID_LIVE = '放送を停止する'

    exports.AUTO_PLAY_TITLE = '入っています '

    exports.SCREEN_SHARE_ERROR = 'スクリーン共有に失敗しました。やり直してください。'

    exports.PUBLISH_ERROR = '動画の投稿に失敗しました。やり直してください。'

    exports.SUBSCRIBE_ERROR = '動画の読み込みに失敗しました。やり直してください。'

    exports.WEBRTC_SERVER_CONNECT_TIMEOUT = 'ビデオサーバーの接続がタイムアウトしました。やり直してください。'

    exports.CAN_NOT_SCREEN_SHARE_WHEN_CLASS_END = '授業が終了しました。スクリーン共有ができません。'

    exports.PPT_VIDEO_SWITCH_CONTENT_TIP
        = 'ビデオウィンドウとホワイトボードの位置を切り替えて、学生側は同時に切り替えますか？'

    exports.PPT_VIDEO_SWITCH_LOCAL = 'ローカルのみ切り替え'

    exports.PPT_VIDEO_SWITCH_ALL = '同期切り替え'

    exports.CLASS_HISTORY_BACK_TIP = '戻る'

    exports.HISTORY_BACK_ALERT_TIP = 'ライブルームを離れるかどうか？'

    exports.RESULT_SCOPE_JINGXI = '金貨'

    exports.TIP_ROOM_SERVER_LOGIN_KICKED_OUT = '教室を蹴られました。教室を変えられません。'

    exports.LOTTERY_TIME_STOP = '抽選を打ち切る'

    exports.LOTTERY_TIME_STOP_TIP = '抽選は中止しますか？'

    exports.TEXT_LOTTERY_SUCCESS = '抽選に参加しました。開賞を待ってください。'

    exports.TEXT_LOTTERY_COMMAND_FAIL = 'パスワードの入力が間違っています。もう一度入力してください。'

    exports.TEXT_LOTTERY_CLOSE_NO_SUBMIT = 'まだ情報を提出していませんが、確実にクローズしますか？'

    exports.TEXT_LOTTERY_TEACHER_OPENED = 'ただいま抽選中です。'

    exports.TEXT_VOTE_TEACHER_OPENED = 'ただいま投票中です。'

    exports.TEXT_TEACHER_TITLE = '投票を始める'

    exports.CLASS_STATUS_STOP_WARMING_UP = '暖場をとめる'

    exports.TEXT_DETELE_WHITEBOARD = '現在のホワイトボードと内容を削除しますか？'

    exports.INFO_PLAYER_LOW_UPLINK_AUDIO_BANDWIDTH
        = 'システムがあなたのマイクの異常を検出しました。このデバイスを再接続してください。'

    exports.INFO_RED_PACKET_CREATE_FAIL = 'お年玉の作成に失敗しました'

    exports.CLEAR_ALL_SHAPE_TIP
        = '<p><icon>！</icon>確認は全部クリアしますか？</p><p>この操作はすべての編集、表示内容をクリアし、元に戻すことができません。慎重に操作してください<p>'

    exports.CLEAR_ALL_SHAPE_OK_TIP = 'すべてクリア'

    exports.CAN_NOT_PUSH_WEBRTC_STREAM
        = '現在のブラウザはライ麦がサポートされていません。最新のchromeまたはクライアントを使ってください。'

    exports.TEXT_FORBID_CLASS_START_END = '授業時間がまだ来ていません。'

    exports.CONFIRM_EXIT_CLASSROOM_FORBID_END_CLASS = '今は授業が終わっていませんが、まだ終了しますか？'

    exports.CONFIRM_LOCATE_PREV_PAGE_END_CLASS = '前のページに戻ると自動的に終了しますか？'

    exports.CONFIRM_LOCATE_PREV_PAGE_EXIT_CLASSROOM = '前のページに戻るとすぐに教室を終了します。戻りますか？'

    exports.BUTTON_SWITCH_MIX_MAIN_USER = 'ビデオのレイアウトを切り替えます'

    exports.TITLE_SIWTCH_MIX_MAIN_USER = '切り替え後、麦下学生が見た映像を同期して表示します。'

    exports.MIX_USER_SCREEN_CHANGE_TIP = '${userName}がメイン画面に切り替わりました'

    exports.LOTTERY_HISTORY_LIST = '当籤記録'

    /**
     * 低版本 app 不支持作业功能提示
     */
    exports.ALERT_TITLE = 'ヒント'

    exports.ALERT_FIND_LOW_VERSION_APP_IN_CLASS_NOT_SUPPORT_HOMEWORK = '移動先はこの機能をサポートしていません。'

    exports.TIP_I_KONW = '分かりました'

    exports.BUTTON_AUTHORIZE_H5_PPT = 'h 5レッスンの許可'

    exports.BUTTON_AUTHORIZE_H5_PPT_OFF = '授権を取り消す'

    exports.TIP_AUTHORIZE_H5_PPT_ON = '全授権済みh 5課'

    exports.TIP_AUTHORIZE_H5_PPT_OFF = 'h 5授業全体の授権をキャンセルしました。'

    exports.WEBRTC_TYPE_CHANGE_TIP = 'この部屋は回線が変わりました。部屋に入ります。少々お待ちください。'

    exports.TIP_DISABLE_CONTROLL_FORBID_ALL = '先生はすでに全禁言を開いた。'

    exports.TIP_NOT_ALLOW_AUTHORIZE_H5_PPT = '学生のページをめくることは禁止されています。授業を許可してはいけません。'

    exports.TIP_CANCEL_AUTHORIZE_H5_PPT = '学生のページをめくることを禁止します。授業の許可をキャンセルしました。'

    /**
     * safari flv 拉流提示
     */
    exports.LABEL_SAFARI_FLV_PULL_TIPS
        = '生放送動画を取得できませんでしたか？safariブラウザの「このサイト設定...」を開き、自動再生を「全自動再生可能」に設定します。'

    /**
     * =================================================
     * 外接手机摄像头
     * =================================================
     */
    exports.DIALOG_TITLE_PHONE_CAMERA_QRCODE = 'ビデオの生放送'

    exports.TIP_USE_PHONE_CAMERA_QRCODE = 'クラウド教室appを使ってコードをスキャンして生放送してください。'

    exports.DIALOG_TITLE_STOP_PHONE_CAMERA = '外部接続機器の生放送を終了します。'

    exports.TIP_OPEN_MAIN_CAMERA = 'メインデバイスのカメラを開く'

    /**
     * 屏幕共享音源选择
     */
    exports.SCREEN_SHARE_AUDIO_SELECT_TITLE = 'サウンドソースを選択'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC = 'マイクの音を共有する'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC_TIPS = 'スクリーン共有時には、マイクの音が聞こえます。'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM = 'システム音を共有'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_1 = 'スクリーン共有時に、学生があなたのシステム音を聞きます。'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_2 = '（例えば、qqメッセージ提示、音楽、ビデオ再生など）'

    /**
     * =================================================
     * 美颜
     * =================================================
     */
    exports.DIALOG_TITLE_CLIP_IMAGE = 'スクリーンショット'

    exports.TIP_INIT_BEAUTY_FAIL = '美顔プログラムの初期化に失敗しました。'

    exports.SETTING_LABEL_BEAUTY = '美顔フィルタ'

    exports.SETTING_LABEL_VIRTUAL_BG = '仮想背景'

    exports.SETTING_TIP_WEB_BEAUTY
        = '美顔フィルタ<br/>1をオンにすると、一定のメモリとCPUを占有します。<br/>2,あなたがウェブサイトで顔を綺麗にする時にカートンを使わないようにハードウェアを起動してください。<br/>3、より多くの美顔&仮想背景の高度な効果が必要なら、バックグラウンドを開通して、クライアントで使用してください。'

    /**
     * =================================================
     * 选择显身 / 隐身
     * =================================================
     */
    exports.LABEL_ASSISTANT_VISIBLE_TIPS = '授業の助教でしたら、身分を示して入ってください。他の人に見られます。'

    exports.LABEL_ASSISTANT_HIDDEN_TIPS
        = '監課・巡回助教の場合は、身を隠して入るようにしてください。他の人には見えません。'

    exports.LABEL_ASSISTANT_ENTER = '入ります'

    /**
     * =================================================
     * 摄像机采集模式切换
     * =================================================
     */
    exports.HINT_CLIENT_VIDEO_CAPTURE_MODE_CHANGE_DIALOG_TEXT
        = 'カメラの採集モードの設定はソフトウェアを再起動した後に有効になります。今ソフトウェアを再起動しますか？'

    /**
     * =================================================
     * 积分
     * =================================================
     */
    exports.BONUS_BUBBLE_TIP = '積分'

    exports.BONUS_MY_POINTS = '私のポイント'

    exports.BONUS_POINTS_RANK = 'ポイントランキング'

    exports.BONUS_POINTS_NOT_ENOUNGH = 'ポイントが足りないので、この操作ではポイントが出ません。'

    /**
     * =================================================
     * 智写云笔手写板
     * =================================================
     */
    exports.TIP_HAND_WRITTING_BOARD_CONNECTED = 'タブレット接続に成功しました。'

    exports.TIP_HAND_WRITTING_BOARD_DISCONNECTED = 'タブレットが切断されました。'

    exports.TIP_HAND_WRITTING_BOARD_SLEEP
        = 'タブレットが休眠しました。外付けのタブレットの電源ボタンを押してデバイスを起こしてください。'

    exports.CONFIRM_TITLE_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = 'システムのヒント'

    exports.CONFIRM_CONTENT_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = '外付けのタブレットとの接続を切断しますか？'

    exports.CANVAS_SWITCH_TO_WHITEBOARD = 'ホワイトボードに切り替え'

    exports.CANVAS_SWITCH_TO_DOCUMENT = 'コースウェアに切り替えます：${name}'

    /**
     * =================================================
     * 抢答器
     * =================================================
     */

    exports.TIP_USER_OFFLINE = 'その学生は教室にいません。'

    exports.TIP_USER_ON_STAGE_ALREADY = 'その学生はもう麦を食べました。'

    exports.TIP_NOT_ALLOW_SPEAK = '現在のライブでは上麦はサポートされていません'

    /**
     * =================================================
     * 检测录制
     * =================================================
     */
    exports.TIP_RECORD_SOFTWARE_CHECKED
        = 'プログラムが記録画面を検出しました。録画ソフトをオフにして、クライアントを再起動して見てください。'

    /**
     * =================================================
     * 转播
     * =================================================
     */
    exports.INFO_CAN_NOT_OPERATE_MEDIA_WHEN_TRANSFER_CLASS
        = '中継中は音声ビデオやコースウェアの管理に関する操作はできません'

    exports.CONFIRM_END_TRANSFER_CLASS = '中継中ですが、中継はオフになりますか？'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_TRANSFER_CLASS_END = '中継が終わるまでメディアで放送してはいけません。'

    exports.INFO_CAN_NOT_START_TRANSFER_CLASS_BEFORE_START_CLASS = '授業はまだ始まっていません。中継は使えません。'

    exports.CAN_NOT_STOP_RTMP_PUSH_WHEN_TRANSFER_CLASS_BEGIN = '中継機能による放送禁止'

    exports.COMMON_ERROR_PAGE_TIP_PREFIX = ''

    /**
     * =================================================
     * 打开摄像头提示
     * =================================================
     */
    exports.INFO_IF_OPEN_CAMERA = 'カメラをオンにするかどうか?'

    exports.BUTTON_NOT_OPEN_CAMERA = '開かない'

    exports.BUTTON_OPEN_CAMERA = '開く'

    /**
     * =================================================
     * 字幕
     * =================================================
     */
    exports.BUTTON_CAPTION = 'タイトル'

    exports.BUTTON_CLOSE_CAPTION = '字幕を閉じる'

    /**
     * =================================================
     * 福袋
     * =================================================
     */
    exports.TIP_END_LUCKY_BAG = '福袋が止まると回復しませんので、慎重に操作してください'

    /**
     * =================================================
     * PK 功能
     * =================================================
     */
    exports.TIP_PK_USER_NOT_ENOUGH = '発言できる人数が足りない'

    exports.TIP_PK_USER_OUT = '教室を終了しました。PKメンバーを再設定してください'

    /**
     * =================================================
     * 打开网页
     * =================================================
     */
    exports.TIP_CLOSE_WEB_PAGE = 'ウィンドウを閉じて学生ページを回収します。続けますか？'

    exports.TIP_PAGE_CANCEL = 'ホームページが閉じられました'

    exports.MANAGE_EXPLORER = 'エクスプローラ'

    exports.ELECTRON_CLIENT_AVSDK_CAN_NOT_PUSH_STREAM_TIP = 'Electronバージョンは現在の音声ビデオの下層プッシュストリームの使用をサポートしていません。公式サイトでCEFバージョンをダウンロードして使用してください！'

    /**
     * =================================================
     * 白板导出
     * =================================================
     */

    exports.BLACKBOARD_EXPORT = '板書の保存'
    /**
     * =================================================
     * 自定义推流布局
     * =================================================
     */
    exports.VIDEO_LAYOUT_SETTING = 'カスタムPushフローレイアウト'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_VIDEO_LAYOUT = 'カスタムプッシュフローレイアウトを閉じる前にメディア再生を使用することはできません'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_VIDEO_LAYOUT = 'カスタムPushフローレイアウトを閉じる前に画面共有を使用することはできません'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_SCREEN_SHARE = '画面共有を閉じる前にカスタムPushフローレイアウトを使用することはできません'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_MEDIA_FILE = 'ビデオを閉じる前にカスタムプッシュフローレイアウトを使用することはできません'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_PLAYBACK = '再生を閉じる前にカスタムプッシュフローレイアウトを使用することはできません'

    exports.INFO_PUBLISH_VIDEO_LAYOUT_SHOULD_BE_PRESENTER = 'カスタムPushフローレイアウトを使用できるのは、担当者のみです'

    /**
     * =================================================
     * 切换 WebRTC 节点
     * =================================================
     */
    exports.BUTTON_SWITCH_WEBRTC_NODE = 'WebRTCノードを切り替える'

    exports.INFO_CAN_NOT_SWITCH_WEBRTC_NODE_IN_WEBRTC_MIX = 'WebRTCミックス中はWebRTCノードを切り替えることはできません'

    /**
     * =================================================
     * 本地录制提示
     * =================================================
     */
    exports.INFO_CONFIRM_STOP_LOCAL_RECORD = 'ローカル録画中、ローカル録画を中止しますか？'

    exports.INFO_LOCAL_RECORD_GENERATE = 'ローカル録画ビデオ生成では、ライブルームを離れることはできません。'

    exports.INFO_LOCAL_RECORD_HAS_GENERATE = 'ローカル録画ビデオが生成されました。'

    /**
     * =================================================
     *  推荐卡片
     * =================================================
     */
    exports.TITLE_RECOMMEND_CARD = '推奨カード'

    /**
     * =================================================
     *  申请开麦
     * =================================================
     */
    exports.MIC_APPLY_DESC = 'マイクを開く申請'
    
    exports.MIC_REJECT_TIP = '先生はあなたのマイクの申請を拒否しました。'

    exports.MIC_ACCEPT_TIP = '先生はあなたのマイクの申請を受け入れました。'

    exports.TIP_ON_WALL = 'あなたの発言が選ばれて黒板に掲示されました!'

    /**
     * =================================================
     *  cpu 提示
     * =================================================
     */
    exports.TIP_CPU_HIGH_LIMIT_SCREEN_SHARE = "システムは現在のCPUが70%を超えていることを検出し、「画面共有」を使用すると生中継異常を招き、オンをサポートしない！"

    exports.TIP_CPU_HIGH_LIMIT_BEAUTY = "システムは現在のCPUが70%を超えていることを検出し、「美顔/仮想背景」をオンにすると生中継の異常を招き、オンをサポートしない！"

    exports.TIP_CPU_HIGH_END_SCREEN_SHARE = "システムは現在のCPUが80%を超えていることを検出し、「画面共有」を使用するとライブの異常が発生し、共有を中断しました！"

    exports.TIP_CPU_HIGH_END_BEAUTY = "システムは現在のCPUが80%を超えていることを検出し、「美顔/仮想背景」を使用し続けると生中継が異常になり、オフになります！"
})
